import { useState, useMemo, useEffect } from "react";
import * as DW from "./affinity_docs_onb_write_api";
import * as OUT from "./affinity_output";
import * as EW from "./affinity_entity_write_api";
import * as EA from "./affinity_eadmin_api";
import { filterEntitiesByAccess } from "./affinity_core_rbac";
import { REGISTERS as RAW_REGISTERS, REGISTER_ORDER } from "./affinity_core_compliance";
// "breaches" is rendered by its own view in Compliance and has no catalogue entry.
const COMPLIANCE_REGISTERS = { breaches:{ label:"Breach log", cols:["Date","Entity","Description","Severity","Status"], rows:[] }, ...RAW_REGISTERS };
import { isConfigured } from "./affinity_accounting_supabase";
import { eaEntitiesList, eaProfile, eaOfficers, eaShareholders, eaCharges, eaUbos, eaAddresses, eaMeetings,
  eaBanks, eaAssets, eaDividends, eaSafeItems, eaFileNotes, eaSafeMovements, eaSignatories,
  repAum, repBankBalances, repSafeCustody, repSignatories } from "./affinity_eadmin_api";
import EntityChart from "./affinity_core_entity_chart";
import AffinityEGaming from "./affinity_core_egaming";
import { COUNTRIES, NATIONALITIES } from "./affinity_countries";
import { messageFor } from "./affinity_action";
const CY = "#00C4CC";
const NAVY = "#001242";

const Badge = ({ label, colors }) => (
  <span style={{ display:"inline-block", padding:"2px 9px", borderRadius:20, fontSize:10, fontWeight:600, background:colors?.bg||"#eee", color:colors?.color||"#333", whiteSpace:"nowrap" }}>{label}</span>
);

const officeColors = {
  "Isle of Man":    { bg:"#E6F7FB", color:"#0077A8" },
  "Malta":          { bg:"#EEF0FB", color:"#3C3489" },
  "Cayman Islands": { bg:"#E6EEF7", color:"#0D4A7A" },
  "United Kingdom": { bg:"#F1EFE8", color:"#444441" },
  "Miami":          { bg:"#FBEAF0", color:"#72243E" },
  "South Dakota":   { bg:"#F1EFE8", color:"#555" },
  "Cyprus":         { bg:"#E6EEF7", color:"#0D4A7A" },
};
const jurShort = { "Isle of Man":"IOM","Malta":"MLT","Cayman Islands":"CYM","United Kingdom":"UK","Miami":"MIA","South Dakota":"SD","Cyprus":"CYP" };
const riskColors = { "Very High":{bg:"#F7C1C1",color:"#501313"}, High:{bg:"#FCEBEB",color:"#A32D2D"}, Medium:{bg:"#FAEEDA",color:"#633806"}, Low:{bg:"#EAF3DE",color:"#27500A"} };
const statusBadge = s => ({ Active:{bg:"#EAF3DE",color:"#27500A"}, Dormant:{bg:"#FAEEDA",color:"#633806"}, "In liquidation":{bg:"#FCEBEB",color:"#A32D2D"}, Dissolved:{bg:"#F1EFE8",color:"#888"}, "Pending incorporation":{bg:"#E6F7FB",color:"#0077A8"} }[s]||{bg:"#eee",color:"#666"});

const ENTITIES = [
  { id:1,  name:"Meridian Holdings Ltd",          ref:"AC-2024-001", type:"Company",    jur:"Isle of Man",    status:"Active",        risk:"Medium",   admin:"Roxy Sheeley",  manager:"Roxy Sheeley",  director:"Andy Morgan", group:"Meridian Group",   principalActivity:"Holding company", yearEnd:"31/03", currency:"GBP", regNo:"117843C",    incorporated:"12/03/2018", isGaming:false },
  { id:2,  name:"Harrington Family Trust",        ref:"AC-2019-014", type:"Trust",      jur:"Isle of Man",    status:"Active",        risk:"High",     admin:"Roxy Sheeley",  manager:"Roxy Sheeley",  director:"Andy Morgan", group:"Harrington Family",principalActivity:"Family trust",    yearEnd:"05/04", currency:"GBP", regNo:"T-4421",     incorporated:"05/07/2019" },
  { id:3,  name:"Caledonian Ventures Ltd",        ref:"AC-2021-032", type:"Company",    jur:"Cayman Islands", status:"Active",        risk:"Medium",   admin:"Garry Crossan", manager:"Garry Crossan", director:"Andy Morgan", group:"Caledonian Group", principalActivity:"Investment holding",yearEnd:"31/12",currency:"USD", regNo:"CY-88341",   incorporated:"22/01/2021" },
  { id:4,  name:"Azure Mediterranean Foundation", ref:"AC-2020-008", type:"Foundation", jur:"Malta",          status:"Active",        risk:"Low",      admin:"Joanne Fenech", manager:"Joanne Fenech", director:"Andy Morgan", group:"Azure Group",      principalActivity:"Philanthropy",    yearEnd:"31/12", currency:"EUR", regNo:"MLT-F-2201", incorporated:"14/09/2020" },
  { id:5,  name:"Thornbury Asset Co Ltd",         ref:"AC-2017-055", type:"Company",    jur:"United Kingdom", status:"Dormant",       risk:"Medium",   admin:"Neil Kelly",    manager:"Neil Kelly",    director:"Andy Morgan", group:"Thornbury Group",  principalActivity:"Asset holding",   yearEnd:"31/12", currency:"GBP", regNo:"14421876",   incorporated:"03/06/2017" },
  { id:6,  name:"Pacific Wealth Trust",           ref:"AC-2022-019", type:"Trust",      jur:"Cayman Islands", status:"Active",        risk:"High",     admin:"Garry Crossan", manager:"Garry Crossan", director:"Andy Morgan", group:"Pacific Wealth",   principalActivity:"Wealth trust",    yearEnd:"31/12", currency:"USD", regNo:"T-CY-5521",  incorporated:"18/11/2022" },
  { id:7,  name:"Stonebridge Capital Ltd",        ref:"AC-2023-041", type:"Company",    jur:"Malta",          status:"Active",        risk:"Low",      admin:"Joanne Fenech", manager:"Joanne Fenech", director:"Andy Morgan", group:"Stonebridge Group",principalActivity:"Capital management",yearEnd:"31/12",currency:"EUR",regNo:"MLT-C-88221",incorporated:"07/02/2023" },
  { id:8,  name:"North Star Holdings Ltd",        ref:"AC-2016-003", type:"Company",    jur:"Isle of Man",    status:"In liquidation",risk:"High",     admin:"Roxy Sheeley",  manager:"Roxy Sheeley",  director:"Andy Morgan", group:"North Star Group", principalActivity:"Holding company", yearEnd:"31/12", currency:"GBP", regNo:"104322C",    incorporated:"30/10/2016" },
  { id:9,  name:"Rosewood Legacy Trust",          ref:"AC-2021-027", type:"Trust",      jur:"Isle of Man",    status:"Active",        risk:"Medium",   admin:"Roxy Sheeley",  manager:"Roxy Sheeley",  director:"Andy Morgan", group:"Cheshire Family",  principalActivity:"Family trust",    yearEnd:"05/04", currency:"GBP", regNo:"T-6603",     incorporated:"25/04/2021" },
  { id:10, name:"Apex Growth Fund Ltd",           ref:"AC-2023-052", type:"Company",    jur:"Cayman Islands", status:"Active",        risk:"Very High",admin:"Garry Crossan", manager:"Garry Crossan", director:"Andy Morgan", group:"Apex Group",       principalActivity:"Fund management", yearEnd:"31/12", currency:"USD", regNo:"CY-99102",   incorporated:"12/08/2023" },
  { id:11, name:"Suncoast Ventures LLC",          ref:"AC-2024-007", type:"Company",    jur:"Miami",          status:"Active",        risk:"Low",      admin:"Andy Morgan",   manager:"Andy Morgan",   director:"Andy Morgan", group:"Suncoast Group",   principalActivity:"Ventures",        yearEnd:"31/12", currency:"USD", regNo:"FL-2024-881", incorporated:"01/03/2024" },
  { id:12, name:"Bluewater Family Trust",         ref:"AC-2020-031", type:"Trust",      jur:"Cayman Islands", status:"Active",        risk:"Medium",   admin:"Garry Crossan", manager:"Garry Crossan", director:"Andy Morgan", group:"Okafor Family",    principalActivity:"Family trust",    yearEnd:"31/12", currency:"USD", regNo:"T-CY-9921",  incorporated:"19/06/2020" },
  { id:13, name:"Phoenix eGaming Ltd",             ref:"AC-2025-061", type:"Company",    jur:"Isle of Man",    status:"Active",        risk:"High",     admin:"Roxy Sheeley",  manager:"Roxy Sheeley",  director:"Andy Morgan", group:"Phoenix Group",    principalActivity:"eGaming operator", yearEnd:"31/12", currency:"GBP", regNo:"GSC-2025-0441",incorporated:"01/03/2025", isGaming:true },
  { id:14, name:"Meridian Digital Ltd",            ref:"AC-2023-058", type:"Company",    jur:"Isle of Man",    status:"Active",        risk:"Medium",   admin:"Roxy Sheeley",  manager:"Roxy Sheeley",  director:"Andy Morgan", group:"Meridian Group",   principalActivity:"B2B platform supply",yearEnd:"31/12",currency:"GBP",regNo:"GSC-2023-0218",incorporated:"01/06/2023", isGaming:true },
  // Affinity's own group companies — entityClass:"group". Mirrors db_eadmin/006_group_entities.sql
  { id:15, name:"Affinity Group Limited",          ref:"AFG-000",     type:"Company",    jur:"Isle of Man",    status:"Active",        risk:"Low",      admin:"Neil Kelly",    manager:"Neil Kelly",    director:"Andy Morgan", group:"Affinity Group",   principalActivity:"Group holding / parent company",        yearEnd:"31/12", currency:"GBP", regNo:"016232V",  incorporated:"28/06/2018", entityClass:"group" },
  { id:16, name:"Affinity (Isle of Man) Limited",  ref:"AFG-IOM",     type:"Company",    jur:"Isle of Man",    status:"Active",        risk:"Low",      admin:"Roxy Sheeley",  manager:"Roxy Sheeley",  director:"Andy Morgan", group:"Affinity Group",   principalActivity:"Corporate & Trust Service Provider (CSP)",yearEnd:"31/12",currency:"GBP", regNo:"110310C",  incorporated:"01/03/2004", entityClass:"group" },
  { id:17, name:"Affinity (Malta) Limited",        ref:"AFG-MLT",     type:"Company",    jur:"Malta",          status:"Active",        risk:"Low",      admin:"Joanne Fenech", manager:"Joanne Fenech", director:"Andy Morgan", group:"Affinity Group",   principalActivity:"Corporate services",                    yearEnd:"31/12", currency:"EUR", regNo:"—",        incorporated:"—",          entityClass:"group" },
  { id:18, name:"Affinity (Cayman) Limited",       ref:"AFG-CYM",     type:"Company",    jur:"Cayman Islands", status:"Active",        risk:"Low",      admin:"Garry Crossan", manager:"Garry Crossan", director:"Andy Morgan", group:"Affinity Group",   principalActivity:"Corporate services",                    yearEnd:"31/12", currency:"USD", regNo:"—",        incorporated:"—",          entityClass:"group" },
  { id:19, name:"Affinity (UK) Limited",           ref:"AFG-UK",      type:"Company",    jur:"United Kingdom", status:"Active",        risk:"Low",      admin:"Neil Kelly",    manager:"Neil Kelly",    director:"Andy Morgan", group:"Affinity Group",   principalActivity:"Corporate services",                    yearEnd:"31/12", currency:"GBP", regNo:"—",        incorporated:"—",          entityClass:"group" },
  { id:20, name:"Affinity South Dakota, LLC",      ref:"AFG-SD",      type:"Company",    jur:"Miami",          status:"Active",        risk:"Low",      admin:"Andy Morgan",   manager:"Andy Morgan",   director:"Andy Morgan", group:"Affinity Group",   principalActivity:"Trust services (US)",                   yearEnd:"31/12", currency:"USD", regNo:"—",        incorporated:"—",          entityClass:"group" },
  { id:21, name:"Affinity South Florida, LLC",     ref:"AFG-FL",      type:"Company",    jur:"Miami",          status:"Active",        risk:"Low",      admin:"Andy Morgan",   manager:"Andy Morgan",   director:"Andy Morgan", group:"Affinity Group",   principalActivity:"Corporate services (US)",               yearEnd:"31/12", currency:"USD", regNo:"—",        incorporated:"—",          entityClass:"group" },
];

const ENTITY_DATA = {
  directors: {
    1:[{id:1,name:"James Harrington",role:"Director",appointed:"12/03/2018",resigned:null,nationality:"British",dob:"15/04/1968",address:"The Old Manor, Cheshire, CH3 7YQ"},{id:2,name:"Sarah Cole",role:"Director",appointed:"12/03/2018",resigned:null,nationality:"British",dob:"22/09/1974",address:"42 Douglas Road, Douglas, Isle of Man"}],
    2:[{id:1,name:"Affinity Trust Ltd",role:"Trustee",appointed:"05/07/2019",resigned:null,nationality:"N/A",dob:"N/A",address:"14 Athol Street, Douglas, IOM"}],
    3:[{id:1,name:"Lena Müller",role:"Director / UBO",appointed:"22/01/2021",resigned:null,nationality:"German",dob:"03/11/1980",address:"Hauptstraße 12, Munich, Germany"},{id:2,name:"Patrick Walsh",role:"Director",appointed:"22/01/2021",resigned:null,nationality:"Irish",dob:"17/07/1975",address:"14 Grafton Street, Dublin, Ireland"}],
    10:[{id:1,name:"Sophie Laurent",role:"Director / UBO",appointed:"12/08/2023",resigned:null,nationality:"French",dob:"07/06/1985",address:"12 Rue de Rivoli, Paris, France"},{id:2,name:"David Park",role:"Director",appointed:"12/08/2023",resigned:null,nationality:"South Korean",dob:"23/10/1979",address:"Seoul, South Korea"}],
  },
  shareholders: {
    1:[{id:1,name:"Meridian Trust",type:"Trust",shares:100,class:"Ordinary",pct:"100%",nominal:"£1",paid:"£100",regDate:"12/03/2018"}],
    3:[{id:1,name:"Lena Müller",type:"Individual",shares:5000,class:"Ordinary",pct:"100%",nominal:"$1",paid:"$5,000",regDate:"22/01/2021"}],
    10:[{id:1,name:"Sophie Laurent",type:"Individual",shares:6000,class:"Ordinary",pct:"60%",nominal:"$1",paid:"$6,000",regDate:"12/08/2023"},{id:2,name:"David Park",type:"Individual",shares:4000,class:"Ordinary",pct:"40%",nominal:"$1",paid:"$4,000",regDate:"12/08/2023"}],
  },
  addresses: {
    1:[{type:"Registered office",address:"2nd Floor, 14 Athol Street, Douglas, Isle of Man, IM1 1JA",from:"12/03/2018",to:null},{type:"Correspondence",address:"The Old Manor, Cheshire, CH3 7YQ",from:"12/03/2018",to:null}],
    2:[{type:"Registered office",address:"2nd Floor, 14 Athol Street, Douglas, Isle of Man, IM1 1JA",from:"05/07/2019",to:null}],
    10:[{type:"Registered office",address:"Harbour Place, 103 South Church Street, George Town, Cayman Islands",from:"12/08/2023",to:null},{type:"Principal office",address:"12 Rue de Rivoli, Paris, France",from:"12/08/2023",to:null}],
  },
  bankAccounts: {
    1:[{id:1,bank:"Barclays Bank",account:"Current account",number:"****4421",currency:"GBP",signatories:"Andy Morgan, Roxy Sheeley",resolution:"12/03/2018",closed:null}],
    3:[{id:1,bank:"First Caribbean Bank",account:"USD account",number:"****8821",currency:"USD",signatories:"Garry Crossan, Andy Morgan",resolution:"22/01/2021",closed:null}],
    10:[{id:1,bank:"Butterfield Bank",account:"USD account",number:"****9102",currency:"USD",resolution:"12/08/2023",closed:null}],
  },
  charges: {
    1:[{id:1,chargee:"HSBC Bank plc",type:"Fixed charge",amount:"£500,000",registered:"15/06/2020",satisfied:null,currency:"GBP"}],
    10:[{id:1,chargee:"Scotiabank Cayman",type:"Fixed charge",amount:"$1,200,000",registered:"12/08/2023",satisfied:null,currency:"USD"}],
  },
  assets: {
    1:[{id:1,desc:"Commercial property — Manchester",acquired:"01/06/2020",lastValuation:"31/12/2024",value:"£1,200,000",currency:"GBP",notes:"Freehold. Tenanted."}],
    2:[{id:1,desc:"Investment portfolio — UK equities",acquired:"05/07/2019",lastValuation:"31/12/2024",value:"£2,400,000",currency:"GBP",notes:"Managed by Harrington Asset Management"}],
    10:[{id:1,desc:"Fund interests — Cayman SPC",acquired:"12/08/2023",lastValuation:"31/12/2024",value:"$8,500,000",currency:"USD",notes:"Segregated Portfolio Company interests"}],
  },
  dividends: {
    1:[{id:1,class:"Ordinary",name:"James Harrington",requested:"15/03/2025",paid:"30/03/2025",perShare:"£500",notes:"Q1 2025 dividend"}],
  },
  nameChanges: {
    8:[{id:1,oldName:"North Star Ventures Ltd",newName:"North Star Holdings Ltd",effective:"15/06/2019",applied:"15/06/2019"}],
  },
  foreignRegs: {
    3:[{id:1,country:"BVI",lastReturn:"22/01/2024",nextReturn:"22/01/2025",lastAccounts:"31/12/2023",nextAccounts:"30/09/2024",notes:"Dormant BVI registration"}],
  },
  fileNotes: {
    1:[{id:1,date:"14/07/2025",author:"Roxy Sheeley",subject:"Client call — Q3 review",note:"Spoke with James Harrington re Q3 accounts. Expects turnover similar to Q2. No changes to structure anticipated."}],
    2:[{id:1,date:"12/07/2025",author:"Colette Grisdale",subject:"KYC chase — Emma Harrington",note:"Third request for updated passport sent. No response. Escalating to MLRO."}],
  },
  meetings: {
    1:[{id:1,type:"Board meeting",date:"15/03/2025",location:"Douglas, Isle of Man",attendees:"James Harrington, Sarah Cole, Andy Morgan",agenda:"Q1 accounts review, dividend declaration",status:"Minutes drafted"}],
    10:[{id:1,type:"Board meeting",date:"12/01/2025",location:"Paris (video)",attendees:"Sophie Laurent, David Park, Andy Morgan",agenda:"Q4 2024 accounts, strategy review",status:"Minutes executed"}],
  },
  safeItems: {
    2:[{id:1,item:"Original trust deed",deposited:"05/07/2019",retrieved:null,auth:"Andy Morgan"}],
    1:[{id:1,item:"Original certificate of incorporation",deposited:"12/03/2018",retrieved:null,auth:"Andy Morgan"}],
  },
  relations: {
    1:[{id:1,name:"James Harrington",role:"Beneficial owner / Director",dob:"15/04/1968",nationality:"British",shared:true,linkedEntities:["Harrington Family Trust","Thornbury Asset Co Ltd"]}],
    2:[{id:1,name:"James Harrington",role:"Settlor",dob:"15/04/1968",nationality:"British",shared:true,linkedEntities:["Meridian Holdings Ltd","Thornbury Asset Co Ltd"]},{id:2,name:"Emma Harrington",role:"Beneficiary",dob:"12/08/1998",nationality:"British",shared:false,linkedEntities:[]}],
  },
};

const TABS = [
  { id:"overview",   label:"Overview",                group:"Entity" },
  { id:"directors",  label:"Officers",                group:"Entity" },
  { id:"shareholders",label:"Shareholders",           group:"Entity" },
  { id:"bank",       label:"Bank accounts",           group:"Entity" },
  { id:"charges",    label:"Charges",                 group:"Entity" },
  { id:"assets",     label:"Assets",                  group:"Entity" },
  { id:"dividends",  label:"Dividends",               group:"Entity" },
  { id:"relations",  label:"Beneficial owners",        group:"Entity" },
  { id:"meetings",   label:"Meetings",                group:"Entity" },
  { id:"structure",  label:"Structure / chart",       group:"Entity" },
  { id:"fileNotes",  label:"File notes",              group:"Entity" },
  { id:"archive",    label:"Archive",                 group:"Entity" },
  { id:"safe",       label:"Safe custody",            group:"Entity" },
  { id:"registers",  label:"Generate registers",      group:"Entity" },
  { id:"compliance", label:"Compliance register",     group:"Regulatory" },
  { id:"egaming_reg",   label:"Gaming",               group:"Registers" },
  { id:"fatca",      label:"FATCA",                   group:"Filing Obligations" },
  { id:"crs",        label:"CRS",                     group:"Filing Obligations" },
  { id:"substance",  label:"Substance",               group:"Filing Obligations" },
];

const s = {
  // Small inline action button used on the register rows.
  mini: { padding:"3px 8px", fontSize:10, borderRadius:5, cursor:"pointer",
          border:"0.5px solid #D9DEE5", background:"transparent", color:"#333" },
  wrap:  { fontFamily:"'Catamaran',system-ui,sans-serif", background:"var(--bg-primary,#fff)", color:"var(--text-primary,#111)", height:"100vh", display:"flex", flexDirection:"column", overflow:"hidden" },
  hdr:   { display:"flex", alignItems:"center", justifyContent:"space-between", padding:"12px 20px", borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)", flexShrink:0 },
  logo:  { fontSize:18, fontWeight:500, color:CY },
  body:  { display:"flex", flex:1, overflow:"hidden" },
  list:  { width:280, minWidth:280, borderRight:"0.5px solid var(--border-tertiary,#e5e5e5)", display:"flex", flexDirection:"column", overflow:"hidden" },
  listHdr:{ padding:"10px 14px", borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)", background:"var(--bg-secondary,#f9f9f9)", flexShrink:0 },
  listBody:{ flex:1, overflowY:"auto" },
  detail:{ flex:1, display:"flex", flexDirection:"column", overflow:"hidden" },
  detHdr:{ padding:"14px 20px", borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)", flexShrink:0 },
  tabBar:{ display:"flex", gap:2, padding:"8px 16px", borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)", background:"var(--bg-secondary,#f9f9f9)", flexWrap:"nowrap", overflowX:"auto", flexShrink:0 },
  tabBtn:(a)=>({ padding:"4px 11px", fontSize:11, borderRadius:20, border:`0.5px solid ${a?"#ccc":"var(--border-tertiary,#e5e5e5)"}`, background:a?"var(--bg-primary,#fff)":"transparent", color:a?"var(--text-primary,#111)":"var(--text-secondary,#666)", cursor:"pointer", fontWeight:a?500:400, whiteSpace:"nowrap", flexShrink:0 }),
  tabBody:{ flex:1, overflowY:"auto", padding:"14px 20px" },
  eRow:  (sel)=>({ display:"flex", alignItems:"center", gap:10, padding:"9px 14px", cursor:"pointer", borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)", background:sel?"var(--bg-secondary,#f9f9f9)":"transparent", transition:"background 0.1s" }),
  avatar:{ width:30, height:30, borderRadius:6, background:"#E6F7FB", color:"#0077A8", fontSize:11, fontWeight:600, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 },
  card:  { background:"var(--bg-primary,#fff)", border:"0.5px solid var(--border-tertiary,#e5e5e5)", borderRadius:8, padding:14, marginBottom:12 },
  cardT: { fontSize:10, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.4px", color:"var(--text-secondary,#666)", marginBottom:10 },
  dRow:  { display:"flex", justifyContent:"space-between", padding:"5px 0", borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)", fontSize:12 },
  dKey:  { color:"var(--text-secondary,#666)", flexShrink:0, maxWidth:"45%" },
  dVal:  { fontWeight:500, textAlign:"right", overflow:"hidden", textOverflow:"ellipsis" },
  th:    { padding:"7px 12px", textAlign:"left", fontSize:10, fontWeight:600, color:"var(--text-secondary,#666)", textTransform:"uppercase", letterSpacing:"0.4px", borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)", background:"var(--bg-secondary,#f9f9f9)", whiteSpace:"nowrap" },
  td:    { padding:"8px 12px", fontSize:11, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)" },
  btn:   (p)=>({ padding:"5px 12px", borderRadius:5, border:p?"none":"0.5px solid var(--border-secondary,#ccc)", background:p?CY:"transparent", color:p?"#fff":"var(--text-primary,#111)", fontSize:11, cursor:"pointer", whiteSpace:"nowrap" }),
  sw:    { display:"flex", alignItems:"center", gap:6, background:"var(--bg-primary,#fff)", border:"0.5px solid var(--border-secondary,#ccc)", borderRadius:5, padding:"0 8px", height:30 },
  swI:   { border:"none", background:"transparent", fontSize:12, outline:"none", width:"100%", color:"var(--text-primary,#111)" },
  sel:   { height:28, padding:"0 6px", fontSize:11, borderRadius:5, border:"0.5px solid var(--border-secondary,#ccc)", background:"var(--bg-primary,#fff)", color:"var(--text-primary,#111)", cursor:"pointer" },
  g2:    { display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 },
  g3:    { display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10, marginBottom:12 },
  g4:    { display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:10, marginBottom:12 },
  kpi:   { background:"var(--bg-secondary,#f9f9f9)", borderRadius:6, padding:"10px 12px" },
  modal: { position:"fixed", top:0, left:0, right:0, bottom:0, background:"rgba(13,27,42,0.45)", display:"flex", alignItems:"flex-start", justifyContent:"center", paddingTop:40, zIndex:100 },
  modalBox:{ background:"var(--bg-primary,#fff)", borderRadius:10, border:"0.5px solid var(--border-tertiary,#e5e5e5)", padding:22, width:520, maxWidth:"96vw", maxHeight:"90vh", overflowY:"auto" },
  fg:    { display:"flex", flexDirection:"column", gap:3, marginBottom:10 },
  fgl:   { fontSize:11, color:"var(--text-secondary,#666)" },
  fgi:   { fontSize:12, borderRadius:5, border:"0.5px solid var(--border-secondary,#ccc)", background:"var(--bg-primary,#fff)", color:"var(--text-primary,#111)", padding:"0 8px", height:32, outline:"none" },
  fgGrid:{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 },
};

const Tbl = ({ cols, rows }) => (
  <div style={{ overflowX:"auto" }}>
    <table style={{ width:"100%", borderCollapse:"collapse", tableLayout:"fixed" }}>
      <thead><tr>{cols.map(c=><th key={c.l} style={{ ...s.th, width:c.w }}>{c.l}</th>)}</tr></thead>
      <tbody>{rows}</tbody>
    </table>
  </div>
);

const KpiGrid = ({ items }) => (
  <div style={{ display:"grid", gridTemplateColumns:`repeat(${items.length},1fr)`, gap:10, marginBottom:14 }}>
    {items.map(k=><div key={k.l} style={s.kpi}><div style={{ fontSize:10, color:"var(--text-secondary,#666)", marginBottom:3 }}>{k.l}</div><div style={{ fontSize:18, fontWeight:500, color:k.c||"var(--text-primary,#111)" }}>{k.v}</div></div>)}
  </div>
);

function getInitials(name) {
  return name.split(" ").slice(0,2).map(w=>w[0]).join("").toUpperCase();
}


// ── FATCA Tab ─────────────────────────────────────────────────
function FATCATab({entity}) {
  const [modal,setModal]=useState(null);
  const data={
    status:entity?.jur==="Isle of Man"||entity?.jur==="Cayman Islands"?"Registered":"Not applicable",
    giin:entity?.id===1?"7FHKP2.00000.SP.833":entity?.id===3?"4KPML9.00000.SP.136":entity?.id===10?"9RQVN1.00000.SP.136":null,
    classification:entity?.type==="Trust"?"Reporting FI — Trustee Documented Trust":entity?.type==="Foundation"?"Non-Reporting FI — Exempt Beneficial Owner":"Reporting FI — Investment Entity",
    usPersons:"None identified",
    filingDue:entity?.jur==="Isle of Man"?"31 May 2026":entity?.jur==="Cayman Islands"?"31 July 2026":"N/A",
    lastFiling:entity?.jur==="Isle of Man"?"31 May 2025":entity?.jur==="Cayman Islands"?"31 July 2025":"N/A",
    filingStatus:"Complete",
    reportingCountry:"Isle of Man" || entity?.jur,
    exchangePartner:"IRS (USA)",
  };
  const isApplicable=["Isle of Man","Cayman Islands","Malta","Jersey","Guernsey","BVI"].includes(entity?.jur);
  const Bx=({label,colors})=><span style={{display:"inline-block",padding:"2px 8px",borderRadius:20,fontSize:10,fontWeight:600,background:colors?.bg||"#eee",color:colors?.color||"#333"}}>{label}</span>;
  return <div>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
      <div><div style={{fontSize:14,fontWeight:600}}>FATCA — Foreign Account Tax Compliance Act</div><div style={{fontSize:11,color:"#666",marginTop:2}}>US reporting obligation status for {entity?.name}</div></div>
      {isApplicable&&<button onClick={()=>setModal("fatca")} style={{padding:"5px 14px",borderRadius:5,border:"none",background:"#00C4CC",color:"#fff",fontSize:11,cursor:"pointer"}}>+ Add/edit FATCA data</button>}
    </div>
    {!isApplicable?<div style={{background:"#f9f9f9",borderRadius:8,padding:20,textAlign:"center",color:"#aaa",fontSize:12}}>FATCA reporting is not applicable for entities in {entity?.jur}.</div>:
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
      <div style={{background:"#fff",border:"0.5px solid #e5e5e5",borderRadius:8,padding:14}}>
        <div style={{fontSize:10,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.4px",color:"#666",marginBottom:10}}>Registration</div>
        {[["Status",<Bx label={data.status} colors={data.status==="Registered"?{bg:"#EAF3DE",color:"#27500A"}:{bg:"#FAEEDA",color:"#633806"}}/>],["GIIN",data.giin||"Not registered"],["Classification",data.classification],["US persons identified",data.usPersons],["Reporting country",data.reportingCountry],["Exchange partner",data.exchangePartner]].map(([k,v])=>(
          <div key={k} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",borderBottom:"0.5px solid #e5e5e5",fontSize:12}}><span style={{color:"#666"}}>{k}</span><span style={{fontWeight:500,textAlign:"right",maxWidth:220}}>{v}</span></div>
        ))}
      </div>
      <div style={{background:"#fff",border:"0.5px solid #e5e5e5",borderRadius:8,padding:14}}>
        <div style={{fontSize:10,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.4px",color:"#666",marginBottom:10}}>Filing history</div>
        {[["Filing status",<Bx label={data.filingStatus} colors={{Complete:{bg:"#EAF3DE",color:"#27500A"},Outstanding:{bg:"#FCEBEB",color:"#A32D2D"}}[data.filingStatus]||{bg:"#eee",color:"#666"}}/>],["Last filing",data.lastFiling],["Next filing due",data.filingDue],["Filing method","AEOI portal — "+data.reportingCountry],["Reportable accounts","0"],["Nil return",data.giin?"Yes — nil return filed":"N/A"]].map(([k,v])=>(
          <div key={k} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",borderBottom:"0.5px solid #e5e5e5",fontSize:12}}><span style={{color:"#666"}}>{k}</span><span style={{fontWeight:500,textAlign:"right",maxWidth:220}}>{v}</span></div>
        ))}
        <div style={{marginTop:12,display:"flex",gap:6}}>
          <button style={{flex:1,padding:"6px",borderRadius:5,border:"0.5px solid #ccc",background:"transparent",fontSize:11,cursor:"pointer"}} disabled title="Needs the document generation engine, which is not built yet">View return ↗</button>
          <button style={{flex:1,padding:"6px",borderRadius:5,border:"none",background:"#00C4CC",color:"#fff",fontSize:11,cursor:"pointer"}} onClick={openPortal}>File return ↗</button>
        </div>
      </div>
    </div>}
  </div>;
}

// ── CRS Tab ───────────────────────────────────────────────────
function CRSTab({entity}) {
  const [modal,setModal]=useState(null);
  const participatingJurs=["Isle of Man","Malta","Cayman Islands","Jersey","Guernsey","United Kingdom","BVI","Cyprus"];
  const isApplicable=participatingJurs.includes(entity?.jur);
  const Bx=({label,colors})=><span style={{display:"inline-block",padding:"2px 8px",borderRadius:20,fontSize:10,fontWeight:600,background:colors?.bg||"#eee",color:colors?.color||"#333"}}>{label}</span>;
  const reportingJurs=entity?.jur==="Isle of Man"?["Germany","France","Netherlands","Sweden","Australia"]:entity?.jur==="Cayman Islands"?["United Kingdom","Germany","France","Australia"]:entity?.jur==="Malta"?["Germany","France","Italy","Spain"]:[];
  return <div>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
      <div><div style={{fontSize:14,fontWeight:600}}>CRS — Common Reporting Standard</div><div style={{fontSize:11,color:"#666",marginTop:2}}>OECD automatic exchange of financial information</div></div>
      {isApplicable&&<button style={{padding:"5px 14px",borderRadius:5,border:"none",background:"#00C4CC",color:"#fff",fontSize:11,cursor:"pointer"}} onClick={()=>setModal("classification")}>+ Add/edit CRS data</button>}
    </div>
    {!isApplicable?<div style={{background:"#f9f9f9",borderRadius:8,padding:20,textAlign:"center",color:"#aaa",fontSize:12}}>CRS reporting does not apply to entities in {entity?.jur}.</div>:
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
      <div style={{background:"#fff",border:"0.5px solid #e5e5e5",borderRadius:8,padding:14}}>
        <div style={{fontSize:10,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.4px",color:"#666",marginBottom:10}}>CRS classification</div>
        {[["CRS status",<Bx label="Reporting FI" colors={{bg:"#EAF3DE",color:"#27500A"}}/>],["Entity classification",entity?.type==="Trust"?"Reporting FI — Trustee Documented":entity?.type==="Foundation"?"Non-Reporting FI":"Reporting FI — Investment Entity"],["Controlling persons identified","Yes — see Relations tab"],["Account holder tax residency","Under review"],["Self-certification obtained","Yes"],["Self-cert date","01/04/2025"],["Self-cert expiry","01/04/2028"]].map(([k,v])=>(
          <div key={k} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",borderBottom:"0.5px solid #e5e5e5",fontSize:12}}><span style={{color:"#666"}}>{k}</span><span style={{fontWeight:500,textAlign:"right",maxWidth:200}}>{v}</span></div>
        ))}
      </div>
      <div style={{background:"#fff",border:"0.5px solid #e5e5e5",borderRadius:8,padding:14}}>
        <div style={{fontSize:10,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.4px",color:"#666",marginBottom:10}}>Reporting jurisdictions</div>
        {reportingJurs.length>0?reportingJurs.map((j,i)=>(
          <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"5px 0",borderBottom:"0.5px solid #e5e5e5",fontSize:12}}>
            <span style={{color:"#666"}}>{j}</span>
            <Bx label="Annual reporting" colors={{bg:"#E6F7FB",color:"#0077A8"}}/>
          </div>
        )):<div style={{fontSize:11,color:"#aaa",padding:"10px 0"}}>No reportable jurisdictions identified.</div>}
        <div style={{marginTop:12,display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
          {[["Last CRS return","31 May 2025"],["Next due","31 May 2026"],["Reportable accounts","0"],["Filing status","Complete"]].map(([k,v])=>(
            <div key={k} style={{background:"#f9f9f9",borderRadius:5,padding:"6px 8px"}}><div style={{fontSize:9,color:"#aaa",marginBottom:2}}>{k}</div><div style={{fontSize:11,fontWeight:500}}>{v}</div></div>
          ))}
        </div>
      </div>
    </div>}
  </div>;
}

// ── Substance Tab ─────────────────────────────────────────────
function SubstanceTab({entity}) {
  const [modal,setModal]=useState(null);
  const substanceJurs=["Isle of Man","Cayman Islands","BVI","Jersey","Guernsey","Bahamas"];
  const isApplicable=substanceJurs.includes(entity?.jur)&&entity?.type!=="Trust"&&entity?.type!=="Foundation";
  const activities=["Holding company","Banking","Insurance","Fund management","Finance and leasing","Headquarters","Distribution and service centre","Intellectual property","Shipping"];
  const entityActivity=entity?.principalActivity||"Holding company";
  const Bx=({label,colors})=><span style={{display:"inline-block",padding:"2px 8px",borderRadius:20,fontSize:10,fontWeight:600,background:colors?.bg||"#eee",color:colors?.color||"#333"}}>{label}</span>;
  return <div>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
      <div><div style={{fontSize:14,fontWeight:600}}>Substance requirements</div><div style={{fontSize:11,color:"#666",marginTop:2}}>Economic substance test — {entity?.jur}</div></div>
      {isApplicable&&<button style={{padding:"5px 14px",borderRadius:5,border:"none",background:"#00C4CC",color:"#fff",fontSize:11,cursor:"pointer"}} onClick={()=>setModal("substance")}>+ Update substance data</button>}
    </div>
    {!isApplicable?<div style={{background:"#f9f9f9",borderRadius:8,padding:20,textAlign:"center",color:"#aaa",fontSize:12}}>
      {entity?.type==="Trust"||entity?.type==="Foundation"?"Substance requirements do not apply to "+entity?.type.toLowerCase()+"s.":"Substance requirements do not apply to entities in "+entity?.jur+"."}
    </div>:
    <div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
        <div style={{background:"#fff",border:"0.5px solid #e5e5e5",borderRadius:8,padding:14}}>
          <div style={{fontSize:10,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.4px",color:"#666",marginBottom:10}}>Activity classification</div>
          <div style={{marginBottom:10}}>
            <div style={{fontSize:11,color:"#666",marginBottom:6}}>Relevant activities (select all that apply):</div>
            {activities.map(a=><div key={a} style={{display:"flex",alignItems:"center",gap:8,padding:"4px 0",borderBottom:"0.5px solid #f5f5f5",fontSize:12}}>
              <div style={{width:14,height:14,borderRadius:3,border:"1px solid #ccc",background:a===entityActivity||a==="Holding company"?"#00C4CC":"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                {(a===entityActivity||a==="Holding company")&&<span style={{color:"#fff",fontSize:9}}>✓</span>}
              </div>
              <span style={{color:a===entityActivity||a==="Holding company"?"#111":"#666"}}>{a}</span>
            </div>)}
          </div>
        </div>
        <div style={{background:"#fff",border:"0.5px solid #e5e5e5",borderRadius:8,padding:14}}>
          <div style={{fontSize:10,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.4px",color:"#666",marginBottom:10}}>Substance test status</div>
          {[["Test applicable","Yes — "+entityActivity],["Substance status",<Bx label="Meets test" colors={{bg:"#EAF3DE",color:"#27500A"}}/>],["CIGA performed in "+entity?.jur,"Yes"],["Adequate employees",entity?.jur==="Isle of Man"?"2 directors — IOM resident":"Review required"],["Adequate premises","Registered office — "+entity?.jur],["Adequate expenditure","Annual fee — meets minimum threshold"],["Board meetings in jurisdiction","1 per year (minimum)"],["Last substance filing","November 2024"],["Next substance due","November 2025"],["Filing status",<Bx label="On track" colors={{bg:"#EAF3DE",color:"#27500A"}}/>]].map(([k,v])=>(
            <div key={k} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",borderBottom:"0.5px solid #e5e5e5",fontSize:12}}><span style={{color:"#666",maxWidth:160}}>{k}</span><span style={{fontWeight:500,textAlign:"right",maxWidth:180}}>{v}</span></div>
          ))}
        </div>
      </div>
      <div style={{background:"#f9f9f9",borderRadius:8,padding:12}}>
        <div style={{fontSize:11,fontWeight:600,marginBottom:8}}>Substance evidence on file</div>
        {[
          {item:"Board meeting minutes — in jurisdiction",status:"✓ Filed",c:"#4CAF7D"},
          {item:"Directors resident in jurisdiction",status:"✓ Confirmed",c:"#4CAF7D"},
          {item:"Accounts / management accounts",status:"✓ Filed",c:"#4CAF7D"},
          {item:"Payroll records (if applicable)",status:"N/A — holding company",c:"#aaa"},
          {item:"CIGA evidence — decision making",status:"✓ Board minutes filed",c:"#4CAF7D"},
        ].map((e,i)=>(
          <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",borderBottom:"0.5px solid #e5e5e5",fontSize:11}}>
            <span style={{color:"#666"}}>{e.item}</span>
            <span style={{color:e.c,fontWeight:500}} dangerouslySetInnerHTML={{__html:e.status}}/>
          </div>
        ))}
      </div>
    </div>}
  </div>;
}


// ─────────────────────────────────────────────────────────────────────────────
// REGISTER ACTIONS
//
// Entity Admin could ADD to every register and change nothing. A director
// could be appointed and never resigned; a UBO added and never corrected or
// removed; an entity opened and never closed. All fifteen functions existed in
// the database with API wrappers, and not one had a button.
//
// That is the worst instance of the gap this audit found, because the register
// is the legal record and the missing operations are the ordinary ones — a
// director resigns, a shareholder transfers, an address changes. A register
// you can only add to is not a register.
//
// AT MODULE LEVEL. A modal defined inside the component is a new function on
// every render, so React remounts it on each keystroke and the state never
// updates. That bug has already been made twice in this build.
// ─────────────────────────────────────────────────────────────────────────────
const ACTION_SPECS = {
  officerResign: {
    title: "Resign an officer",
    note: "The officer stays on the register, marked resigned. Who was a director on a given date is a matter of record — for filings, for liability, and for any later question about who authorised what. A register showing only current officers cannot answer it.",
    cta: "Record the resignation",
    fields: [["resigned", "Resignation date", true, "YYYY-MM-DD"]],
  },
  officerUpdate: {
    title: "Correct an officer's details",
    note: "For correcting what was recorded. If the officer has actually left, resign them instead — that keeps the history.",
    fields: [["name", "Name", true, ""], ["role", "Role", true, ""],
             ["appointed", "Appointed", false, "YYYY-MM-DD"],
             ["nationality", "Nationality", false, ""],
             ["dob", "Date of birth", false, "YYYY-MM-DD"],
             ["taxResidence", "Tax residence", false, ""],
             ["tin", "TIN", false, ""], ["address", "Address", false, ""]],
    cta: "Save the correction",
  },
  uboUpdate: {
    title: "Correct a beneficial owner",
    note: "Ownership percentages should account for 100% across the register. Core reports the total so an incomplete register is visible.",
    fields: [["name", "Name", true, ""], ["role", "Role", false, ""],
             ["dob", "Date of birth", false, "YYYY-MM-DD"],
             ["nationality", "Nationality", false, ""],
             ["ownershipPct", "Ownership %", false, ""],
             ["natureOfControl", "Nature of control", false, ""],
             ["taxResidence", "Tax residence", false, ""], ["tin", "TIN", false, ""]],
    cta: "Save the correction",
  },
  uboRemove: {
    title: "Remove a beneficial owner",
    note: "A reason is required. Removing someone from the beneficial ownership register is a filing matter in most jurisdictions, and the reason is what a later question is answered with.",
    fields: [["reason", "Reason", true, "e.g. holding transferred on 1 May"]],
    cta: "Remove from the register",
  },
  shareholderRemove: {
    title: "Remove a shareholder",
    note: "A reason is required, because a share register is a legal record and a holding that simply disappears cannot be explained afterwards.",
    fields: [["reason", "Reason", true, "e.g. shares transferred to J Smith"]],
    cta: "Remove from the register",
  },
  signatoryRemove: {
    title: "End a signatory's authority",
    note: "The signatory stays on the register with an end date rather than being deleted — who could sign, and when, is exactly what gets asked later.",
    fields: [["toDate", "Authority ends", true, "YYYY-MM-DD"]],
    cta: "End the authority",
  },
  dividendPay: {
    title: "Record a dividend as paid",
    note: "Declaring and paying are separate events, and the gap between them matters for both tax and the accounts.",
    fields: [["paidDate", "Date paid", true, "YYYY-MM-DD"]],
    cta: "Record the payment",
  },
  safeRetrieve: {
    title: "Retrieve an item from safe custody",
    note: "Who authorised the retrieval is recorded, because physical custody of certificates and deeds is something a client or a regulator will ask about.",
    fields: [["retrievedDate", "Date retrieved", true, "YYYY-MM-DD"],
             ["authorisedBy", "Authorised by", true, ""]],
    cta: "Record the retrieval",
  },
  profileUpdate: {
    title: "Edit the entity",
    note: "Changes are recorded in the audit trail with who made them and when.",
    fields: [["regNo", "Registration number", false, ""],
             ["yearEnd", "Year end", false, "e.g. 31 December"],
             ["businessActivity", "Business activity", false, ""],
             ["riskRating", "Risk rating", false, ""],
             ["adminStatus", "Status", false, ""]],
    cta: "Save the changes",
  },
  classification: {
    title: "FATCA and CRS classification",
    note: "The classification drives the reporting obligation. Recording it wrongly means reporting the wrong thing, or nothing at all.",
    fields: [["fatcaClass", "FATCA code", false, "RFI, PNFFE, ANFFE, TDT…"],
             ["crsClass", "CRS code", false, "INVA, PNFE, ANFE, NRFI…"],
             ["giin", "GIIN", false, "required for RFI and DRNFFE"]],
    cta: "Save the classification",
  },
  responsibilities: {
    title: "Who is responsible",
    fields: [["administrator", "Administrator", false, ""],
             ["manager", "Manager", false, ""],
             ["leadDirector", "Lead director", false, ""],
             ["accountant", "Accountant", false, ""],
             ["office", "Office", false, ""]],
    cta: "Save",
  },
  chargeSatisfy: {
    title: "Satisfy a charge",
    note: "A satisfied charge stays on the register with its satisfaction date. Whether security was in place on a given date is exactly what gets asked in a transaction, and a register showing only live charges cannot answer it.",
    cta: "Record the satisfaction",
    fields: [["satisfiedDate", "Date satisfied", true, "YYYY-MM-DD"]],
  },
  bankClose: {
    title: "Close a bank account",
    note: "The account stays on the register with a closing date. Which account was in use when a payment was made is a question that comes up later.",
    cta: "Record the closure",
    fields: [["closedDate", "Date closed", true, "YYYY-MM-DD"]],
  },
  assetRevalue: {
    title: "Revalue an asset",
    note: "Recording a new valuation and the date it was made. The date matters as much as the figure — a valuation with no date cannot be judged as current or stale.",
    cta: "Record the valuation",
    fields: [["value", "New value", true, ""],
             ["valuationDate", "Valuation date", true, "YYYY-MM-DD"]],
  },
  serviceSet: {
    title: "Set a service",
    note: "Which services Affinity provides to this entity. It feeds billing, so a service that is provided and not recorded is one nobody invoices for.",
    cta: "Save",
    fields: [["service", "Service", true, ""],
             ["active", "Active? yes or no", true, "yes"]],
  },
  entityClose: {
    title: "Close the entity",
    note: "Closing sets the status and keeps every record. Core refuses to close an entity with unbilled time against it, because closing writes that work off — bill it or write it off deliberately first.",
    fields: [["reason", "Reason", true, ""],
             ["closedDate", "Closed date", true, "YYYY-MM-DD"]],
    cta: "Close the entity",
  },
  caseload: {
    title: "Reassign a caseload",
    note: "Moves every entity from one person to another in a single step. Reassigning forty entities one at a time is how one gets missed, and the one that gets missed is the one nobody administers. Core reports how many moved, and refuses if nothing matched.",
    fields: [["fromName", "From", true, ""], ["toName", "To", true, ""],
             ["roleField", "Which role", true, "administrator / manager / lead_director"]],
    cta: "Reassign",
  },
};

function ActionModal({ spec, f, setF, msg, busy, subject, onCancel, onSave }) {
  if (!spec) return null;
  const d = ACTION_SPECS[spec];
  if (!d) return null;
  return (
    <div onClick={(e) => e.target === e.currentTarget && onCancel()}
         style={{ position:"fixed", inset:0, background:"rgba(0,18,66,0.45)",
                  display:"flex", alignItems:"center", justifyContent:"center",
                  zIndex:1200, padding:20 }}>
      <div style={{ background:"#fff", borderRadius:12, padding:"22px 24px",
                    width:"min(640px,100%)", maxHeight:"86vh", overflowY:"auto" }}>
        <div style={{ fontSize:15, fontWeight:600, color:"#001242", marginBottom:6 }}>
          {d.title}
        </div>
        {subject && (
          <div style={{ fontSize:12, color:"#5B6B7B", marginBottom:8 }}>{subject}</div>
        )}
        {d.note && (
          <div style={{ fontSize:11.5, color:"#5B6B7B", lineHeight:1.7, marginBottom:14 }}>
            {d.note}
          </div>
        )}
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"12px 14px" }}>
          {d.fields.map(([k, lab, req, ph]) => (
            <div key={k} style={{ gridColumn: (k==="reason"||k==="address"||
                                               k==="businessActivity") ? "1/-1" : "auto" }}>
              <label style={{ display:"block", fontSize:11, fontWeight:600,
                              color:"#555", marginBottom:4 }}>
                {lab}{req && <span style={{ color:"#A32D2D" }}> *</span>}
              </label>
              <input value={f[k] || ""} placeholder={ph}
                     onChange={(e) => setF({ ...f, [k]: e.target.value })}
                     style={{ width:"100%", height:34, fontSize:12.5, borderRadius:6,
                              border:"0.5px solid #ccc", padding:"0 8px" }} />
            </div>
          ))}
        </div>
        {msg && (
          <div style={{ marginTop:14, padding:"9px 12px", borderRadius:7, fontSize:11.5,
                        lineHeight:1.6, background:"#FCEBEB", border:"0.5px solid #f0c9c9",
                        color:"#A32D2D", whiteSpace:"pre-wrap" }}>{msg}</div>
        )}
        <div style={{ display:"flex", gap:8, justifyContent:"flex-end", marginTop:18 }}>
          <button style={{ padding:"6px 13px", borderRadius:6, fontSize:11.5,
                           cursor:"pointer", border:"0.5px solid #D9DEE5",
                           background:"transparent" }} onClick={onCancel}>Cancel</button>
          <button style={{ padding:"6px 13px", borderRadius:6, fontSize:11.5,
                           cursor:"pointer", border:"none", background:"#00C4CC",
                           color:"#fff" }} onClick={onSave} disabled={busy}>{d.cta}</button>
        </div>
      </div>
    </div>
  );
}

// A date field gets a date picker. Every register in this module asked for
// DD/MM/YYYY as free text — twenty-three of them — which means somebody types
// 01/02/26 and the next person cannot tell whether that was January or
// February, and a typo becomes a date in 2126 that nothing questions.
//
// Detected from the label rather than declared per field, because there are
// twenty-three of them and the twenty-fourth would have been missed.
// Which fields cannot be left blank. Required is the DEFAULT — a register entry
// with half its fields empty is the thing that gets asked about three years
// later — and the exceptions are the kinds legitimately empty: an end date on
// something that has not ended, a note, anything the label calls optional.
//
// A rule rather than a flag on each of the hundred-odd fields, for the same
// reason as the date detection: a flag somebody has to remember to set is the
// flag that is missing on the field that mattered.
function isRequiredField(f) {
  if (!f) return false;
  if (f.required === false) return false;
  if (f.required === true) return true;
  const l = String(f.label || "").toLowerCase();
  const p = String(f.placeholder || "").toLowerCase();
  if (/optional|if any|leave blank|or blank/.test(l + " " + p)) return false;
  // An end, a closing, a satisfaction or a resignation has usually not happened
  // yet — which is what makes the register worth keeping.
  // "end date" and "ended", but NOT "year end" — an entity's year end is
  // required, and a bare \bend\b made it optional. Caught by running the rule
  // over every real field label rather than reading it.
  if (/\bclosed\b|\bclosing\b|end date|\bended\b|\bresign|\bsatisf|\bremoved\b|\bexit\b|\buntil\b|discharged/.test(l)) return false;
  if (/\bnote|\bcomment|\bdetail|\bmemo\b/.test(l)) return false;
  return true;
}

function isDateField(f) {
  if (!f) return false;
  if (f.type) return f.type === "date";
  const l = String(f.label || "").toLowerCase();
  const p = String(f.placeholder || "");
  return /\bdate\b|\bdated\b|\bfrom\b|\buntil\b|\bexpiry\b|\bdeposited\b|\bincorporated\b/.test(l)
      || /DD\/MM\/YYYY/.test(p);
}

export default function AffinityCoreEntityAdmin({ officeFilter="", onNav, role="system_admin", internalRefs }) {
  // ── Output plumbing ───────────────────────────────────────────────────────
  const [outMsg, setOutMsg] = useState("");
  const outRun = (fn) => {
    try {
      const res = fn();
      if (res && res.ok === false) { setOutMsg(res.error || "That could not be produced."); return false; }
      setOutMsg("");
      return true;
    } catch (e) { setOutMsg(String((e && e.message) || e)); return false; }
  };

  // Statutory documents built from the entity's own record. Each opens as a
  // printable view the browser saves as PDF; each is watermarked DRAFT because
  // a template minute still needs reviewing before it reaches the books.
  const docEntity = () => ({
    name: entity && entity.name, ref: entity && entity.ref,
    regNo: (det && det.profile && det.profile.reg_no) || (entity && entity.regNo),
    jur: entity && entity.jur,
    registeredOffice: det && det.addresses && det.addresses[0] && det.addresses[0].address,
  });

  const genMinutes = () => outRun(() => OUT.boardMinutes({
    entity: docEntity(),
    meetingDate: new Date().toLocaleDateString("en-GB"),
    present: (det && det.officers || []).filter(o=>!o.resigned).map(o=>o.name).slice(0,8),
    apologies: [],
    business: [],
  }));

  const genResolution = () => outRun(() => OUT.boardResolution({
    entity: docEntity(),
    resolutionDate: new Date().toLocaleDateString("en-GB"),
    resolutions: [],
  }));

  // Register extracts. Which register depends on the tab you are on, so the
  // same button serves all of them rather than one per register.
  const registerRows = () => {
    if (!det) return { name: "Register", headers: [], rows: [] };
    switch (tab) {
      case "officers": return { name: "Register of Directors and Officers",
        headers: ["Name","Role","Appointed","Resigned","Nationality"],
        rows: (det.officers||[]).map(o=>[o.name,o.role,fmtD(o.appointed),o.resigned?fmtD(o.resigned):"—",o.nationality]) };
      case "shareholders": return { name: "Register of Members",
        headers: ["Name","Class","Shares","Holding %","Held from"],
        rows: (det.shareholders||[]).map(s=>[s.name,s.share_class,s.shares,s.pct,fmtD(s.held_from)]) };
      case "ubos": case "relations": return { name: "Register of Beneficial Owners",
        headers: ["Name","Role","Nationality","Ownership %","Nature of control"],
        rows: (det.ubos||[]).map(u=>[u.name,u.role,u.nationality,u.ownership_pct,u.nature_of_control]) };
      case "charges": return { name: "Register of Charges",
        headers: ["Chargee","Type","Amount","Registered","Satisfied"],
        rows: (det.charges||[]).map(c=>[c.chargee,c.charge_type,c.amount,fmtD(c.registered_date),c.satisfied_date?fmtD(c.satisfied_date):"—"]) };
      case "meetings": return { name: "Register of Meetings",
        headers: ["Type","Date","Notes"],
        rows: (det.meetings||[]).map(m=>[m.meeting_type,fmtD(m.meeting_date),m.notes]) };
      default: return { name: "Register", headers: [], rows: [] };
    }
  };

  const printRegister = () => {
    const r = registerRows();
    if (!r.rows.length) { setOutMsg("There is nothing in this register to produce."); return; }
    outRun(() => OUT.registerExtract({ entity: docEntity(), registerName: r.name,
                                       headers: r.headers, rows: r.rows }));
  };

  const exportRegister = () => {
    const r = registerRows();
    if (!r.rows.length) { setOutMsg("There is nothing in this register to export."); return; }
    const label = (entity && entity.ref ? entity.ref + " " : "") + r.name;
    outRun(() => OUT.downloadTableCSV(label, r.headers, r.rows));
  };

  // Filing happens on the regulator's own portal — none of them gives us an
  // API — so this opens the right one and leaves the submission to be recorded
  // against the filing in Core.
  const openPortal = () => outRun(() => OUT.openRegulatorPortal(entity && entity.jur));

  const [sel, setSel]       = useState(1);
  const [tab, setTab]       = useState("overview");
  const [search, setSearch] = useState("");
  const [classF, setClassF] = useState("");  // ""=all, "client", "group"
  const [jurF, setJurF]     = useState("");
  const [typeF, setTypeF]   = useState("");
  const [statF, setStatF]   = useState("");
  const [modal, setModal]   = useState(null);
  const [reportsOpen, setReportsOpen] = useState(false);
  const [gamingReg, setGamingReg] = useState("");
  const [repTab, setRepTab] = useState("aum");
  const [repRows, setRepRows] = useState([]);
  const [repLoading, setRepLoading] = useState(false);
  const REPORTS = {
    aum:  { label:"Assets under management", fetch:()=>repAum(),          cols:[["entity","Entity"],["jurisdiction","Jurisdiction"],["description","Asset"],["acquired","Acquired"],["value","Value"],["ccy","Ccy"],["disposed","Disposed"],["disposal_value","Disposal value"],["status","Status"]] },
    bank: { label:"Bank balances (FSA)",      fetch:()=>repBankBalances(), cols:[["entity","Entity"],["bank","Bank"],["account_name","Account"],["ccy","Ccy"],["balance","Balance"],["balance_date","As at"],["iban","IBAN"],["sort_code","Sort code"]] },
    safe: { label:"Safe custody & archiving",  fetch:()=>repSafeCustody(null), cols:[["entity","Entity"],["record_type","Type"],["item","Item"],["location","Location"],["box_number","Box no."],["deposited","Deposited"],["retrieved","Retrieved"],["authorised_by","Authorised by"]] },
    sig:  { label:"Authorised signatories",    fetch:()=>repSignatories(),  cols:[["entity","Entity"],["signatory","Signatory"],["category","Category"],["class","Class"],["bank","Bank"],["from_date","From"],["to_date","To"]] },
  };

  // Map office name to jurisdiction for cross-filter
  const officeToJur = {
    "Isle of Man":"Isle of Man","Malta":"Malta",
    "Cayman Islands":"Cayman Islands","United Kingdom":"United Kingdom",
    "Miami":"United States","Cyprus":"Cyprus"
  };
  const activeJurF = officeFilter && officeFilter !== "All" ? officeToJur[officeFilter] : jurF;

  const [liveEnts, setLiveEnts] = useState(null);
  const [loadError, setLoadError] = useState("");
  const [det, setDet] = useState(null);
  const [detVersion, setDetVersion] = useState(0);   // bumped after a save so the register reloads
  const fmtD = (s) => (s ? String(s).split("-").reverse().join("/") : null);

  // load live client portfolio
  useEffect(() => {
    if (!isConfigured) return;
    let ok = true;
    eaEntitiesList().then((res) => {
      if (!ok) return;
      const { data, error } = res || {};
      // SAID OUT LOUD, because this failing silently is why nothing can be
      // saved. liveEnts stays false, entityDbId stays null, and every Save in
      // the module is disabled with a note about the entity not being loaded —
      // which reads as a problem with the entity rather than with this call.
      //
      // Andy hit exactly that: "This entity is not loaded from the database."
      // True, and useless, because nothing said why not.
      if (error) { setLoadError(messageFor(error)); return; }
      if (!data) { setLoadError("The entity list came back empty — not signed in, or the API could not be reached."); return; }
      if (!data.length) { setLoadError("No entities are in the database yet."); return; }
      setLoadError("");
      const mapped = data.map((r) => {
        const demo = ENTITIES.find((e) => e.ref === r.ref) || {};
        // is_demo comes from the DATABASE, not from whether a bundled record
        // happens to share the reference — a real client migrated under a
        // reference the sample set also used must not inherit the flag.
        return { ...demo, is_demo: r.is_demo, id: r.id, ref: r.ref, name: r.name, type: r.entity_type, jur: r.jurisdiction,
                 status: r.admin_status, risk: r.risk_rating, incorporated: fmtD(r.incorporation_date), entityClass: r.entity_class };
      });
      setLiveEnts(mapped);
      setSel((s) => (mapped.find((e) => e.id === s) ? s : mapped[0].id));
    }).catch(() => {});
    return () => { ok = false; };
  }, []);

  // load selected entity detail
  useEffect(() => {
    if (!isConfigured || !liveEnts || sel == null) { setDet(null); return; }
    let ok = true;
    Promise.all([eaProfile(sel), eaOfficers(sel), eaShareholders(sel), eaCharges(sel), eaUbos(sel), eaAddresses(sel), eaMeetings(sel),
                 eaBanks(sel), eaAssets(sel), eaDividends(sel), eaSafeItems(sel), eaFileNotes(sel), eaSafeMovements(sel), eaSignatories(sel)])
      .then(([p, o, sh, c, u, a, m, bk, as, dv, sf, fn, sm, sg]) => { if (ok) setDet({
        profile: (p.data && p.data[0]) || null, officers: o.data || [], shareholders: sh.data || [],
        charges: c.data || [], ubos: u.data || [], addresses: a.data || [], meetings: m.data || [],
        banks: bk.data || [], assets: as.data || [], dividends: dv.data || [], safe: sf.data || [], fileNotes: fn.data || [],
        safeMovements: sm.data || [], signatories: sg.data || [] }); })
      .catch(() => { if (ok) setDet(null); });
    return () => { ok = false; };
  }, [sel, liveEnts, detVersion]);

  // Internal-vs-client scoping: a role without "group" access never sees Affinity's
  // own entities anywhere in this module (portfolio, search, counts, reports).
  const allEnts = liveEnts || ENTITIES;
  // Affinity's own companies are checked one by one, not as a single switch.
  const ents    = useMemo(()=>filterEntitiesByAccess(allEnts, role, internalRefs),[allEnts,role,internalRefs]);

  useEffect(()=>{
    if(!reportsOpen || !isConfigured) return;
    let ok=true; setRepLoading(true);
    REPORTS[repTab].fetch().then(({data})=>{ if(ok){ setRepRows(data||[]); setRepLoading(false); } })
      .catch(()=>{ if(ok){ setRepRows([]); setRepLoading(false); } });
    return ()=>{ok=false;};
  },[reportsOpen, repTab]);
  const exportRepCsv = () => {
    const cols = REPORTS[repTab].cols;
    const head = cols.map(c=>c[1]).join(",");
    const body = repRows.map(r=>cols.map(c=>`"${String(r[c[0]]??"").replace(/"/g,'""')}"`).join(",")).join("\n");
    const blob = new Blob([head+"\n"+body], { type:"text/csv" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = `affinity-${repTab}-report.csv`; a.click();
  };

  const filtered = useMemo(()=>ents.filter(e=>
    (!search||e.name.toLowerCase().includes(search.toLowerCase())||e.ref.toLowerCase().includes(search.toLowerCase()))&&
    (!activeJurF||e.jur===activeJurF)&&(!typeF||e.type===typeF)&&(!statF||e.status===statF)&&(!classF||(e.entityClass||"client")===classF)
  ),[search,activeJurF,typeF,statF,classF,jurF,officeFilter,ents]);

  // entity-class counts for the Internal/Client scope control
  const classCounts = useMemo(()=>ents.reduce((a,e)=>{
    const k=(e.entityClass||"client")==="group"?"group":"client"; a[k]=(a[k]||0)+1; return a;
  },{client:0,group:0}),[ents]);

  // Anything from the bundled ENTITIES constant is the preview dataset, which
  // is sample data by definition. Flagged here so the badge shows in preview
  // too — previously preview and live records looked identical on screen.
  // A bundled record has no is_demo from the database, and everything in the
  // bundled set IS sample data — so absent means demo rather than unknown.
  // Defaulting the other way would show preview records as real clients.
  const baseEntity = ents.find(e=>e.id===sel);
  const entity = (det && det.profile)
    ? { ...baseEntity, regNo:det.profile.reg_no, yearEnd:det.profile.year_end, principalActivity:det.profile.business_activity,
        jur:det.profile.jurisdiction, type:det.profile.entity_type, incorporated:fmtD(det.profile.incorporation_date),
        status:det.profile.admin_status, risk:det.profile.risk_rating, companiesAct:det.profile.incorporation_regime, regulator:det.profile.regulator, mlroOfficer:det.profile.mlro, regOffice:det.profile.registered_office, auditStatus:det.profile.audit_status,
        // Responsibility fields. These had no columns until db/064 and so only
        // ever appeared in the demonstration data; real records showed blank.
        administrator:det.profile.administrator, manager:det.profile.manager,
        leadDirector:det.profile.lead_director, accountant:det.profile.accountant,
        office:det.profile.office,
        entityClass:baseEntity.entityClass }
    : baseEntity;
  const dirs     = det ? det.officers.map(o=>({ id:o.id, name:o.name, role:o.role, appointed:fmtD(o.appointed), resigned:fmtD(o.resigned), nationality:o.nationality, dob:fmtD(o.dob), address:o.address, tin:o.tin, taxResidence:o.tax_residence }))  : (ENTITY_DATA.directors[sel]||[]);
  const shares   = det ? det.shareholders.map(x=>({ id:x.id, name:x.name, type:"—", shares:x.shares, class:x.share_class, pct:(x.pct!=null?x.pct+"%":"—"), nominal:"—", paid:"—", regDate:fmtD(x.held_from) })) : (ENTITY_DATA.shareholders[sel]||[]);
  const addrs    = det ? det.addresses.map(a=>({ type:a.address_type, address:a.address, from:fmtD(a.from_date), to:a.to_date?fmtD(a.to_date):null })) : (ENTITY_DATA.addresses[sel]||[]);
  const banks    = det ? det.banks.map(b=>({ id:b.id, bank:b.bank, account:b.account_name, number:b.number, currency:b.ccy, signatories:b.signatories, resolution:fmtD(b.resolution_date), closed:b.closed_date?fmtD(b.closed_date):null, iban:b.iban, sortCode:b.sort_code, balance:b.balance, balanceDate:b.balance_date?fmtD(b.balance_date):null })) : (ENTITY_DATA.bankAccounts[sel]||[]);
  const charges  = det ? det.charges.map(c=>({ id:c.id, chargee:c.chargee, type:c.charge_type, amount:(c.ccy||"")+" "+Number(c.amount||0).toLocaleString(), registered:fmtD(c.registered_date), satisfied:c.satisfied_date?fmtD(c.satisfied_date):null, currency:c.ccy })) : (ENTITY_DATA.charges[sel]||[]);
  const assets   = det ? det.assets.map(a=>({ id:a.id, desc:a.description, acquired:fmtD(a.acquired_date), lastValuation:fmtD(a.last_valuation_date), value:(a.ccy||"")+" "+Number(a.value||0).toLocaleString(), currency:a.ccy, notes:a.notes, disposal:a.disposal_date?fmtD(a.disposal_date):null, disposalValue:(a.disposal_value!=null?(a.ccy||"")+" "+Number(a.disposal_value).toLocaleString():null) })) : (ENTITY_DATA.assets[sel]||[]);
  const divs     = det ? det.dividends.map(d=>({ id:d.id, class:d.share_class, name:d.name, requested:fmtD(d.requested_date), paid:fmtD(d.paid_date), perShare:d.per_share, notes:d.notes })) : (ENTITY_DATA.dividends[sel]||[]);
  const nameChgs = ENTITY_DATA.nameChanges[sel]||[];
  const forgRegs = ENTITY_DATA.foreignRegs[sel]||[];
  const fileNotes= det ? det.fileNotes.map(f=>({ id:f.id, date:fmtD(f.note_date), author:f.author, employee:f.employee_name, linkedEntityId:f.linked_entity_id, subject:f.subject, note:f.note })) : (ENTITY_DATA.fileNotes[sel]||[]);
  const meetings = det ? det.meetings.map(m=>({ id:m.id, type:m.meeting_type, date:fmtD(m.meeting_date), location:"—", attendees:"—", agenda:m.notes, status:"Recorded" })) : (ENTITY_DATA.meetings[sel]||[]);
  const safeItems= det ? det.safe.map(x=>({ id:x.id, item:x.item, deposited:fmtD(x.deposited_date), retrieved:x.retrieved_date?fmtD(x.retrieved_date):null, auth:x.authorised_by, recordType:x.record_type||"Safe custody", location:x.location, boxNumber:x.box_number, description:x.description })) : (ENTITY_DATA.safeItems[sel]||[]);
  const safeMovements = det ? (det.safeMovements||[]).map(m=>({ id:m.id, requestedBy:m.requested_by, action:m.action, date:fmtD(m.movement_date), reason:m.reason })) : [];
  const signatories = det ? (det.signatories||[]).map(s=>({ id:s.id, name:s.name, category:s.category, class:s.class, from:fmtD(s.from_date), to:s.to_date?fmtD(s.to_date):null })) : [];
  const relations= det ? det.ubos.map(u=>({ id:u.id, name:u.name, role:u.role, nature:u.nature_of_control, ownershipPct:u.ownership_pct, dob:fmtD(u.dob), nationality:u.nationality, tin:u.tin, taxResidence:u.tax_residence, shared:false, linkedEntities:[] })) : (ENTITY_DATA.relations[sel]||[]);

  const nb = { padding:"5px 12px", fontSize:11, borderRadius:5, border:"0.5px solid var(--border-tertiary,#e5e5e5)", background:"transparent", color:"var(--text-secondary,#666)", cursor:"pointer" };
  const nba = { ...nb, background:CY, color:"#fff", border:`0.5px solid ${CY}`, fontWeight:500 };

  // One modal serves every register, so wiring it wires all of them. Inputs are
  // controlled and Save calls the register's write function. onSave is supplied
  // per register below; without one the form stays read-only and says so rather
  // than offering a Save that does nothing.
  const FormModal = ({ title, fields, onClose, onSave, note }) => {
    const [vals, setVals]   = useState(() => {
      const v = {};
      fields.forEach((f) => { v[f.key || f.label] = f.type === "select" ? ((f.opts||[])[0] || "") : ""; });
      return v;
    });
    const [busy, setBusy]   = useState(false);
    const [err, setErr]     = useState("");
    const set = (k, val) => setVals((p) => ({ ...p, [k]: val }));

    const submit = async () => {
      if (!onSave) return;

      // "Needs to have a catch all where screens cannot be saved unless every
      // item has been completed."
      //
      // Not taken literally, because that makes the forms unusable: a closing
      // date is blank because the account is open, and forcing somebody to
      // invent a date of birth they do not have produces worse data than an
      // empty field. So a field is required unless it is one of the kinds
      // legitimately often blank, and anything else empty is NAMED before
      // saving rather than discovered afterwards. The person can still proceed
      // — they know things the form does not — but not by accident, which is
      // the actual complaint.
      const blank = (fields || []).filter((f) => {
        const v = vals[f.label];
        return v == null || String(v).trim() === "";
      });
      const hard = blank.filter(isRequiredField);
      if (hard.length) {
        setErr("These cannot be left blank: " + hard.map((f) => f.label).join(", "));
        return;
      }
      const soft = blank.filter((f) => !isRequiredField(f));
      if (soft.length && !window.confirm(
            "These are still empty:\n\n" + soft.map((f) => "    " + f.label).join("\n") +
            "\n\nSave anyway?")) return;

      setBusy(true); setErr("");
      const res = await onSave(vals);
      setBusy(false);
      if (res && res.ok) { onClose(true); }
      else { setErr((res && res.error) || "That could not be saved."); }
    };

    return (
      <div style={s.modal} onClick={e=>e.target===e.currentTarget&&onClose()}>
        <div style={s.modalBox}>
          <div style={{ fontSize:14, fontWeight:600, marginBottom:16 }}>{title}</div>
          <div style={s.fgGrid}>
            {fields.map((f,i)=>{
              const k = f.key || f.label;
              return (
                <div key={i} style={{ ...s.fg, gridColumn:f.full?"1/-1":"auto" }}>
                  <label style={s.fgl}>{f.label}{f.required && <span style={{ color:"#EF4444" }}> *</span>}</label>
                  {f.type==="select"
                    ?<select style={s.fgi} value={vals[k]} onChange={e=>set(k, e.target.value)}>
                       {(f.opts||[]).map(op=><option key={op} value={op}>{op}</option>)}
                     </select>
                    :f.type==="textarea"
                    ?<textarea style={{ ...s.fgi, height:60, padding:"6px 8px" }} placeholder={f.placeholder||""}
                       value={vals[k]} onChange={e=>set(k, e.target.value)} />
                    :(f.type === "country" || f.type === "nationality")
                    ? <>
                        {/* Suggests rather than restricts. A list that refuses an
                            answer is worse than one that suggests: the territories
                            people actually hold passports for outrun any list, and
                            a register that cannot record the truth gets a note
                            beside it instead. */}
                        <input style={s.fgi} list={"list-" + f.type}
                               placeholder="Type to search"
                               value={vals[k]} onChange={e=>set(k, e.target.value)} />
                        <datalist id={"list-" + f.type}>
                          {(f.type === "country" ? COUNTRIES : NATIONALITIES)
                            .map(x => <option key={x} value={x} />)}
                        </datalist>
                      </>
                    : <input style={s.fgi}
                       placeholder={isDateField(f) ? "" : (f.placeholder||"")}
                       type={f.type || (isDateField(f) ? "date" : "text")}
                       value={vals[k]} onChange={e=>set(k, e.target.value)} />
                  }
                </div>
              );
            })}
          </div>

          {note && (
            <div style={{ marginTop:12, fontSize:10.5, color:"#7B4F1D", background:"#FDF4DC",
                          border:"0.5px solid #E5CE9A", borderRadius:6, padding:"8px 10px", lineHeight:1.6 }}>
              {note}
            </div>
          )}
          {err && (
            <div style={{ marginTop:12, fontSize:11.5, color:"#A32D2D", background:"#FCEBEB",
                          border:"0.5px solid #f0c9c9", borderRadius:6, padding:"8px 10px", lineHeight:1.6 }}>
              {err}
            </div>
          )}

          <div style={{ display:"flex", gap:8, justifyContent:"flex-end", marginTop:14 }}>
            <button style={s.btn(false)} onClick={()=>onClose()} disabled={busy}>Cancel</button>
            {onSave
              ? <button style={s.btn(true)} onClick={submit} disabled={busy}>{busy ? "Saving…" : "Save"}</button>
              : <button style={s.btn(true)} disabled
                  title="This register cannot be saved to yet">Save</button>}
          </div>
        </div>
      </div>
    );
  };

  const renderTab = () => {
    if(!entity) return null;
    switch(tab) {

      case "overview": return (
        <div>
          <div style={s.g2}>
            <div style={s.card}>
              <div style={s.cardT}>Core information</div>
              {[
                
                ["Principal activity",entity.principalActivity],
                ["Entity type",entity.type],
                ...(entity.companiesAct?[["Incorporation regime",entity.companiesAct]]:[]),
                ["Jurisdiction",entity.jur],
                ["Registration number",entity.regNo],
                ["Incorporated",entity.incorporated],
                ["Year end",entity.yearEnd],
                ["Currency",entity.currency],
                ["Status",entity.status],
                ["Risk rating",entity.risk],
                ...(entity.auditStatus?[["Audit status", <Bx label={entity.auditStatus} colors={{"Up to date":{bg:"#EAF3DE",color:"#27500A"},"In progress":{bg:"#FAEEDA",color:"#633806"},"Overdue":{bg:"#FCEBEB",color:"#A32D2D"},"Not required":{bg:"#F1EFE8",color:"#888"}}[entity.auditStatus]||{bg:"#eee",color:"#666"}}/>]]:[]),
                ["Registered office", entity.regOffice || `Affinity Group, ${entity.jur}`],
                ...(entity.regulator ? [["Regulator", entity.regulator], ...(entity.mlroOfficer?[["MLRO / Compliance Officer", entity.mlroOfficer]]:[])] : []),
                ["Business address","Same as registered"],
                ["Communication address","Same as registered"],
                ...((entity.foreignRegs && entity.foreignRegs.length>0)
                  ? entity.foreignRegs.map(fr => [`Foreign reg — ${fr.jurisdiction||fr.jur||"—"}`, fr.regNo||fr.number||"—"])
                  : [
                      ["Foreign reg","FR-2024-08821"],
                      ["Foreign reg","C-92847-MFS"],
                    ]),
              ].map(([k,v], i)=>(
                <div key={k+"-"+i} style={s.dRow}><span style={s.dKey}>{k}</span><span style={s.dVal}>{v}</span></div>
              ))}
            </div>
            <div style={s.card}>
              <div style={s.cardT}>Administration</div>
              {[["Administrator",entity.admin],["Manager",entity.manager],["Lead director",entity.director],["Accountant","Neil Kelly"],["MLRO","Colette Grisdale"],["Office",entity.jur]].map(([k,v])=>(
                <div key={k} style={s.dRow}><span style={s.dKey}>{k}</span><span style={s.dVal}>{v}</span></div>
              ))}
              <div style={{ marginTop:10 }}>
                <div style={s.cardT}>Active services</div>
                {["Company administration","Registered office","Director services","Annual return filing"].map(sv=>(
                  <div key={sv} style={{ fontSize:11, padding:"4px 0", borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)", display:"flex", alignItems:"center", gap:6 }}>
                    <span style={{ color:CY }}>✓</span><span style={{ color:"var(--text-secondary,#666)" }}>{sv}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div style={s.g3}>
            <div style={s.card}>
              <div style={s.cardT}>Upcoming reminders</div>
              {[
                { item:"Annual return due",date:"12/03/2026",type:"Filing",sev:"green" },
                { item:"Periodic review due",date:entity.risk==="High"?"18/08/2025":"14/09/2025",type:"Compliance",sev:entity.risk==="High"?"red":"amber" },
                { item:"Year end accounts",date:`30/09/${new Date().getFullYear()}`,type:"Accounts",sev:"blue" },
              ].map((r,i)=>(
                <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"6px 0", borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)", fontSize:11 }}>
                  <div><div style={{ fontWeight:500 }}>{r.item}</div><div style={{ color:"var(--text-secondary,#666)", fontSize:10 }}>{r.type}</div></div>
                  <span style={{ color:{red:"#EF4444",amber:"#F59E0B",green:"#4CAF7D",blue:CY}[r.sev], fontWeight:500 }}>{r.date}</span>
                </div>
              ))}
            </div>
            <div style={s.card}>
              <div style={s.cardT}>Quick summary</div>
              {[["Directors / trustees",dirs.filter(d=>!d.resigned).length],["Shareholders",shares.length],["Bank accounts",banks.length],["Active charges",charges.filter(c=>!c.satisfied).length],["Assets on record",assets.length],["File notes",fileNotes.length],["Meetings recorded",meetings.length]].map(([k,v])=>(
                <div key={k} style={s.dRow}><span style={s.dKey}>{k}</span><span style={s.dVal}>{v||"—"}</span></div>
              ))}
            </div>
            <div style={s.card}>
              <div style={s.cardT}>Memorandum &amp; articles</div>
              {[["Date of M&A","12/03/2018"],["Last amended","N/A"],["Custom clauses","Restriction on transfer of shares"],["Filed with","IOM Companies Registry"],["Copy in DMS","Yes — Certificate + M&A"]].map(([k,v])=>(
                <div key={k} style={s.dRow}><span style={s.dKey}>{k}</span><span style={s.dVal}>{v}</span></div>
              ))}
              <button style={{ ...s.btn(false), marginTop:8, fontSize:10 }} onClick={()=>onNav&&onNav("documents")}>View M&amp;A in Documents ↗</button>
            </div>
          </div>
        </div>
      );

      case "statutory": return (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
            <div style={{ fontSize:12, fontWeight:500 }}>Statutory information — {entity.name}</div>
            <button style={s.btn(true)} onClick={()=>setModal("statutory")}>Edit statutory data</button>
          </div>
          <div style={s.g2}>
            <div style={s.card}>
              <div style={s.cardT}>Registration details</div>
              {[["Registration number",entity.regNo],["Jurisdiction",entity.jur],["Type",entity.type],["Incorporated",entity.incorporated],["Year end",entity.yearEnd],["Tax status","Tax exempt"],["FATCA classification","Passive NFE"],["CRS classification","Passive NFE"],["GIIN","Not applicable"]].map(([k,v])=>(
                <div key={k} style={s.dRow}><span style={s.dKey}>{k}</span><span style={s.dVal}>{v}</span></div>
              ))}
            </div>
            <div style={s.card}>
              <div style={s.cardT}>Filing obligations</div>
              {[["Annual return due","12/03/2026"],["Last annual return filed","12/03/2025"],["Last accounts prepared","31/03/2025"],["Next accounts due","30/09/2025"],["Audit required","No"],["Substance review due","31/12/2025"],["Substance classification","Holding company"],["FATCA return due","31/05/2026"]].map(([k,v])=>(
                <div key={k} style={s.dRow}><span style={s.dKey}>{k}</span><span style={s.dVal}>{v}</span></div>
              ))}
            </div>
          </div>
          {nameChgs.length>0&&(
            <div style={s.card}>
              <div style={s.cardT}>Name changes</div>
              <Tbl cols={[{l:"Old name",w:"30%"},{l:"New name",w:"30%"},{l:"Effective date",w:"20%"},{l:"Applied date",w:"20%"}]}
                rows={nameChgs.map(n=>(
                  <tr key={n.id} style={{ borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)" }}>
                    <td style={s.td}>{n.oldName}</td><td style={{ ...s.td, fontWeight:500 }}>{n.newName}</td>
                    <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{n.effective}</td><td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{n.applied}</td>
                  </tr>
                ))}
              />
            </div>
          )}
        </div>
      );

      case "directors": return (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
            <div style={{ fontSize:12, fontWeight:500 }}>{entity.type==="Trust"?"Trustees & parties":"Directors & officers"}</div>
            <button style={s.btn(true)} onClick={()=>setModal("director")}>＋ Appoint officer</button>
          </div>
          <Tbl cols={[{l:"Name",w:"16%"},{l:"Role",w:"13%"},{l:"Appointed",w:"9%"},{l:"Resigned",w:"8%"},{l:"Nationality",w:"10%"},{l:"Tax residence",w:"12%"},{l:"TIN",w:"11%"},{l:"Date of birth",w:"9%"},{l:"Address",w:"12%"},{l:"",w:"10%"}]}
            rows={dirs.map(d=>(
              <tr key={d.id} style={{ borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)", background:d.resigned?"var(--bg-secondary,#f9f9f9)":"transparent" }}>
                <td style={{ ...s.td, fontWeight:500, color:d.resigned?"var(--text-secondary,#666)":undefined }}>{d.name}</td>
                <td style={s.td}><Badge label={d.role} colors={{ Director:{bg:"#E6F7FB",color:"#0077A8"},"Director / UBO":{bg:"#FCEBEB",color:"#A32D2D"}, Trustee:{bg:"#EEF0FB",color:"#3C3489"}, Settlor:{bg:"#EAF3DE",color:"#27500A"}, Beneficiary:{bg:"#FAEEDA",color:"#633806"} }[d.role.split(" / ")[0]]||{bg:"#eee",color:"#666"}} /></td>
                <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{d.appointed}</td>
                <td style={s.td}>{d.resigned?<Badge label="Resigned" colors={{ bg:"#F1EFE8", color:"#888" }} />:<span style={{ color:"var(--text-secondary,#666)" }}>—</span>}</td>
                <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{d.nationality}</td>
                <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{d.taxResidence||"—"}</td>
                <td style={{ ...s.td, color:"var(--text-secondary,#666)", fontFamily:"monospace", fontSize:10 }}>{d.tin||"—"}</td>
                <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{d.dob}</td>
                <td style={{ ...s.td, color:"var(--text-secondary,#666)", overflow:"hidden", textOverflow:"ellipsis" }}>{d.address}</td>
                <td style={s.td}>
                  {entityDbId && !d.resigned && (
                    <>
                      <button style={{ ...s.mini }} title="Keeps the officer on the register, marked resigned"
                              onClick={()=>openAct("officerResign", d.id, d.name)}>Resign</button>
                      <button style={{ ...s.mini, marginLeft:4 }} title="Correct what was recorded"
                              onClick={()=>openAct("officerUpdate", d.id, d.name,
                                { name:d.name, role:d.role, nationality:d.nationality,
                                  taxResidence:d.tax_residence, tin:d.tin, address:d.address })}>Edit</button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          />
          {dirs.length===0&&<div style={{ color:"var(--text-secondary,#666)", fontSize:12, padding:"20px 0", textAlign:"center" }}>No officers recorded. Click '+ Appoint officer' to add.</div>}
        </div>
      );

      case "shareholders": return (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
            <div style={{ fontSize:12, fontWeight:500 }}>Share register — {entity.name}</div>
            <button style={s.btn(true)} onClick={()=>setModal("shareholder")}>＋ Register transfer / issuance</button>
          </div>
          {shares.length>0?(
            <Tbl cols={[{l:"Shareholder",w:"22%"},{l:"Type",w:"10%"},{l:"Shares",w:"10%"},{l:"Class",w:"10%"},{l:"Nominal",w:"10%"},{l:"Paid up",w:"10%"},{l:"%",w:"8%"},{l:"Reg. date",w:"12%"},{l:"",w:"8%"}]}
              rows={shares.map(sh=>(
                <tr key={sh.id} style={{ borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)" }}>
                  <td style={{ ...s.td, fontWeight:500 }}>{sh.name}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{sh.type}</td>
                  <td style={{ ...s.td, textAlign:"right", fontWeight:500 }}>{sh.shares.toLocaleString()}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{sh.class}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{sh.nominal}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{sh.paid}</td>
                  <td style={{ ...s.td, fontWeight:600 }}>{sh.pct}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{sh.regDate}</td>
                <td style={s.td}>
                  {entityDbId && (
                    <button style={s.mini}
                            title="A reason is required — a share register is a legal record and a holding that simply disappears cannot be explained afterwards"
                            onClick={()=>openAct("shareholderRemove", sh.id, sh.name)}>Remove</button>
                  )}
                </td>
                </tr>
              ))}
            />
          ):<div style={{ color:"var(--text-secondary,#666)", fontSize:12, padding:"20px 0", textAlign:"center" }}>{entity.type==="Trust"?"Trust structure — no share register applicable.":"No shareholders recorded."}</div>}
        </div>
      );

      case "addresses": return (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
            <div style={{ fontSize:12, fontWeight:500 }}>Addresses — unlimited address types supported</div>
            <button style={s.btn(true)} onClick={()=>setModal("address")}>＋ Add address</button>
          </div>
          {addrs.length>0?(addrs.map(a=>(
            <div key={a.type} style={{ ...s.card, marginBottom:8 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                <div>
                  <div style={{ fontSize:11, fontWeight:600, color:CY, marginBottom:4 }}>{a.type}</div>
                  <div style={{ fontSize:13, fontWeight:500 }}>{a.address}</div>
                  <div style={{ fontSize:11, color:"var(--text-secondary,#666)", marginTop:4 }}>From {a.from}{a.to?` to ${a.to}`:""}</div>
                </div>
                <button style={s.btn(false)} onClick={()=>setModal("editProfile")}>Edit</button>
              </div>
            </div>
          ))):<div style={{ color:"var(--text-secondary,#666)", fontSize:12, padding:"20px 0", textAlign:"center" }}>No addresses recorded.</div>}
        </div>
      );

      case "bank": return (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
            <div style={{ fontSize:12, fontWeight:500 }}>Bank &amp; broker accounts</div>
            <button style={s.btn(true)} onClick={()=>setModal("bank")}>＋ Add account</button>
          </div>
          {banks.length>0?(
            <Tbl cols={[{l:"Bank / broker",w:"14%"},{l:"Account name",w:"12%"},{l:"Account no.",w:"10%"},{l:"IBAN",w:"16%"},{l:"Sort code",w:"8%"},{l:"Ccy",w:"5%"},{l:"Balance",w:"15%"},{l:"Status",w:"8%"}]}
              rows={banks.map(b=>(
                <tr key={b.id} style={{ borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)" }}>
                  <td style={{ ...s.td, fontWeight:500 }}>{b.bank}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{b.account}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{b.number}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)", fontFamily:"monospace", fontSize:10 }}>{b.iban||"—"}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)", fontFamily:"monospace", fontSize:10 }}>{b.sortCode||"—"}</td>
                  <td style={s.td}>{b.currency}</td>
                  <td style={{ ...s.td, fontWeight:600 }}>{b.balance!=null?`${b.currency||""} ${Number(b.balance).toLocaleString()}`:"—"}{b.balanceDate&&<span style={{ display:"block", fontSize:9, fontWeight:400, color:"var(--text-secondary,#999)" }}>as at {b.balanceDate}</span>}</td>
                  <td style={s.td}><Badge label={b.closed?"Closed":"Active"} colors={b.closed?{bg:"#F1EFE8",color:"#888"}:{bg:"#EAF3DE",color:"#27500A"}} /></td>
                </tr>
              ))}
            />
          ):<div style={{ color:"var(--text-secondary,#666)", fontSize:12, padding:"20px 0", textAlign:"center" }}>No bank accounts recorded.</div>}

          <div style={{ display:"flex", justifyContent:"space-between", margin:"18px 0 10px" }}>
            <div style={{ fontSize:12, fontWeight:500 }}>Authorised signatory list</div>
            <button style={s.btn(true)} onClick={()=>setModal("signatory")}>＋ Add signatory</button>
          </div>
          {signatories.length>0?(
            <Tbl cols={[{l:"Signatory",w:"28%"},{l:"Category",w:"24%"},{l:"Class",w:"16%"},{l:"From",w:"14%"},{l:"To",w:"14%"}]}
              rows={signatories.map(sg=>(
                <tr key={sg.id} style={{ borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)", background:sg.to?"var(--bg-secondary,#f9f9f9)":"transparent" }}>
                  <td style={{ ...s.td, fontWeight:500 }}>{sg.name}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{sg.category||"—"}</td>
                  <td style={s.td}>{sg.class?<Badge label={sg.class} colors={{bg:"#E6F7FB",color:"#0077A8"}} />:"—"}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{sg.from}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{sg.to||"Current"}</td>
                </tr>
              ))}
            />
          ):<div style={{ color:"var(--text-secondary,#666)", fontSize:12, padding:"14px 0", textAlign:"center" }}>No authorised signatories recorded.</div>}
        </div>
      );

      case "charges": return (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
            <div style={{ fontSize:12, fontWeight:500 }}>Charges &amp; security interests</div>
            <button style={s.btn(true)} onClick={()=>setModal("charge")}>＋ Register charge</button>
          </div>
          {charges.length>0?(
            <Tbl cols={[{l:"Chargee / lender",w:"22%"},{l:"Type",w:"14%"},{l:"Amount",w:"14%"},{l:"Currency",w:"10%"},{l:"Registered",w:"12%"},{l:"Discharged",w:"12%"},{l:"Status",w:"12%"}]}
              rows={charges.map(c=>(
                <tr key={c.id} style={{ borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)" }}>
                  <td style={{ ...s.td, fontWeight:500 }}>{c.chargee}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{c.type}</td>
                  <td style={{ ...s.td, fontWeight:600 }}>{c.amount}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{c.currency}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{c.registered}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{c.satisfied||"—"}</td>
                  <td style={s.td}><Badge label={c.satisfied?"Satisfied":"Active"} colors={c.satisfied?{bg:"#F1EFE8",color:"#888"}:{bg:"#FAEEDA",color:"#633806"}} /></td>
                </tr>
              ))}
            />
          ):<div style={{ color:"var(--text-secondary,#666)", fontSize:12, padding:"20px 0", textAlign:"center" }}>No charges registered.</div>}
        </div>
      );

      case "assets": return (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
            <div style={{ fontSize:12, fontWeight:500 }}>Assets</div>
            <button style={s.btn(true)} onClick={()=>setModal("asset")}>＋ Add asset</button>
          </div>
          <div style={{ background:"var(--bg-secondary,#f9f9f9)", borderRadius:6, padding:"8px 12px", fontSize:11, color:"var(--text-secondary,#666)", marginBottom:12 }}>
            ℹ️ Assets are recorded at entity level. This includes all asset types — property, investments, vessels, aircraft, and other holdings.
          </div>
          {assets.length>0?(
            <Tbl cols={[{l:"Description",w:"24%"},{l:"Acquired",w:"11%"},{l:"Last valuation",w:"12%"},{l:"Purchase value",w:"13%"},{l:"Disposed",w:"11%"},{l:"Disposal value",w:"13%"},{l:"Status",w:"8%"},{l:"Notes",w:"8%"}]}
              rows={assets.map(a=>(
                <tr key={a.id} style={{ borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)", background:a.disposal?"var(--bg-secondary,#f9f9f9)":"transparent" }}>
                  <td style={{ ...s.td, fontWeight:500 }}>{a.desc}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{a.acquired}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{a.lastValuation}</td>
                  <td style={{ ...s.td, fontWeight:600 }}>{a.value}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{a.disposal||"—"}</td>
                  <td style={{ ...s.td, fontWeight:a.disposalValue?600:400, color:a.disposalValue?undefined:"var(--text-secondary,#666)" }}>{a.disposalValue||"—"}</td>
                  <td style={s.td}><Badge label={a.disposal?"Disposed":"Held"} colors={a.disposal?{bg:"#F1EFE8",color:"#888"}:{bg:"#EAF3DE",color:"#27500A"}} /></td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)", whiteSpace:"normal", lineHeight:1.3 }}>{a.notes}</td>
                </tr>
              ))}
            />
          ):<div style={{ color:"var(--text-secondary,#666)", fontSize:12, padding:"20px 0", textAlign:"center" }}>No assets recorded.</div>}
        </div>
      );

      case "dividends": return (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
            <div style={{ fontSize:12, fontWeight:500 }}>Dividends</div>
            <button style={s.btn(true)} onClick={()=>setModal("dividend")}>＋ Record dividend</button>
          </div>
          {divs.length>0?(
            <Tbl cols={[{l:"Share class",w:"14%"},{l:"Recipient",w:"20%"},{l:"Date requested",w:"14%"},{l:"Date paid",w:"14%"},{l:"Per share",w:"14%"},{l:"Notes",w:"24%"},{l:"",w:"8%"}]}
              rows={divs.map(d=>(
                <tr key={d.id} style={{ borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)" }}>
                  <td style={s.td}>{d.class}</td>
                  <td style={{ ...s.td, fontWeight:500 }}>{d.name}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{d.requested}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{d.paid}</td>
                  <td style={{ ...s.td, fontWeight:600 }}>{d.perShare}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{d.notes}</td>
                <td style={s.td}>
                  {entityDbId && !d.paid && (
                    <button style={s.mini}
                            title="Declaring and paying are separate events, and the gap matters for tax and the accounts"
                            onClick={()=>openAct("dividendPay", d.id, d.name)}>Mark paid</button>
                  )}
                </td>
                </tr>
              ))}
            />
          ):<div style={{ color:"var(--text-secondary,#666)", fontSize:12, padding:"20px 0", textAlign:"center" }}>No dividends recorded.</div>}
        </div>
      );

      case "foreignRegs": return (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
            <div style={{ fontSize:12, fontWeight:500 }}>Foreign registrations</div>
            <button style={s.btn(true)} onClick={()=>setModal("foreignReg")}>＋ Add registration</button>
          </div>
          {forgRegs.length>0?(
            <Tbl cols={[{l:"Country",w:"14%"},{l:"Last annual return",w:"16%"},{l:"Next annual return",w:"16%"},{l:"Last accounts",w:"14%"},{l:"Next accounts",w:"14%"},{l:"Notes",w:"26%"}]}
              rows={forgRegs.map(f=>(
                <tr key={f.id} style={{ borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)" }}>
                  <td style={{ ...s.td, fontWeight:500 }}>{f.country}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{f.lastReturn}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{f.nextReturn}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{f.lastAccounts}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{f.nextAccounts}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{f.notes}</td>
                </tr>
              ))}
            />
          ):<div style={{ color:"var(--text-secondary,#666)", fontSize:12, padding:"20px 0", textAlign:"center" }}>No foreign registrations recorded.</div>}
        </div>
      );

      case "relations": return (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
            <div style={{ fontSize:12, fontWeight:500 }}>Beneficial owners register — owners &amp; controllers</div>
            <button style={s.btn(true)} onClick={()=>setModal("relation")}>＋ Add beneficial owner</button>
          </div>
          <div style={{ background:"var(--bg-secondary,#f9f9f9)", borderRadius:6, padding:"8px 12px", fontSize:11, color:"var(--text-secondary,#666)", marginBottom:12 }}>
            ℹ️ Beneficial owners (owners &amp; controllers) are held here, distinct from the officer register. A person may appear both here and as an officer where they hold both roles.
          </div>
          {relations.length>0?(
            <Tbl cols={[{l:"Name",w:"18%"},{l:"Nature of control",w:"22%"},{l:"Ownership",w:"9%"},{l:"DOB",w:"11%"},{l:"Nationality",w:"11%"},{l:"Tax residence",w:"11%"},{l:"TIN",w:"11%"},{l:"Record",w:"7%"},{l:"",w:"10%"}]}
              rows={relations.map(r=>(
                <tr key={r.id} style={{ borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)" }}>
                  <td style={{ ...s.td, fontWeight:500 }}>{r.name}{r.role&&<span style={{ display:"block", fontSize:10, fontWeight:400, color:"var(--text-secondary,#999)" }}>{r.role}</span>}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)", whiteSpace:"normal", lineHeight:1.3 }}>{r.nature||"—"}</td>
                  <td style={{ ...s.td, fontWeight:600 }}>{r.ownershipPct!=null?r.ownershipPct+"%":"—"}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{r.dob}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{r.nationality}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{r.taxResidence||"—"}</td>
                  <td style={{ ...s.td, color:"var(--text-secondary,#666)", fontFamily:"monospace", fontSize:10 }}>{r.tin||"—"}</td>
                  <td style={s.td}>{r.shared?<Badge label="Shared" colors={{bg:"#E6F7FB",color:"#0077A8"}} title={r.linkedEntities.join(", ")} />:<span style={{ color:"var(--text-secondary,#999)" }}>—</span>}</td>
                <td style={s.td}>
                  {entityDbId && (
                    <>
                      <button style={s.mini}
                              onClick={()=>openAct("uboUpdate", r.id, r.name,
                                { name:r.name, role:r.role, nationality:r.nationality,
                                  ownershipPct:r.ownershipPct, natureOfControl:r.nature,
                                  taxResidence:r.taxResidence, tin:r.tin })}>Edit</button>
                      <button style={{ ...s.mini, marginLeft:4 }}
                              title="A reason is required — removing a beneficial owner is a filing matter in most jurisdictions"
                              onClick={()=>openAct("uboRemove", r.id, r.name)}>Remove</button>
                    </>
                  )}
                </td>
                </tr>
              ))}
            />
          ):<div style={{ color:"var(--text-secondary,#666)", fontSize:12, padding:"20px 0", textAlign:"center" }}>No beneficial owners recorded.</div>}
        </div>
      );

      case "meetings": return (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
            <div style={{ fontSize:12, fontWeight:500 }}>Meetings</div>
            <button style={s.btn(true)} onClick={()=>setModal("meeting")}>＋ Schedule meeting</button>
          </div>
          {meetings.length>0?(meetings.map(m=>(
            <div key={m.id} style={{ ...s.card, marginBottom:8 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:8 }}>
                <div><div style={{ fontSize:13, fontWeight:600 }}>{m.type} — {m.date}</div>
                  <div style={{ fontSize:11, color:"var(--text-secondary,#666)", marginTop:3 }}>{m.location}</div></div>
                <Badge label={m.status} colors={{ "Minutes drafted":{bg:"#FAEEDA",color:"#633806"}, "Minutes executed":{bg:"#EAF3DE",color:"#27500A"}, Scheduled:{bg:"#E6F7FB",color:"#0077A8"} }[m.status]||{bg:"#eee",color:"#666"}} />
              </div>
              {[["Attendees",m.attendees],["Agenda",m.agenda]].map(([k,v])=>(
                <div key={k} style={s.dRow}><span style={s.dKey}>{k}</span><span style={{ ...s.dVal, maxWidth:300, whiteSpace:"normal", textAlign:"right" }}>{v}</span></div>
              ))}
              <div style={{ display:"flex", gap:6, marginTop:8 }}>
                <button style={{ ...s.btn(false), fontSize:10 }} onClick={genMinutes}>Generate minutes ↗</button>
                <button style={{ ...s.btn(false), fontSize:10 }} onClick={genResolution}>Generate resolution ↗</button>
                <button style={{ ...s.btn(true), fontSize:10 }} onClick={()=>onNav&&onNav("documents")}>View documents ↗</button>
              </div>
            </div>
          ))):<div style={{ color:"var(--text-secondary,#666)", fontSize:12, padding:"20px 0", textAlign:"center" }}>No meetings recorded.</div>}
        </div>
      );

      case "fileNotes": return (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
            <div style={{ fontSize:12, fontWeight:500 }}>File notes</div>
            <button style={s.btn(true)} onClick={()=>setModal("fileNote")}>＋ Add file note</button>
          </div>
          {fileNotes.length>0?(fileNotes.map(n=>{
            const linked = n.linkedEntityId ? (ents.find(e=>e.id===n.linkedEntityId)||{}).name : null;
            return (
            <div key={n.id} style={{ ...s.card, marginBottom:8 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
                <div><div style={{ fontSize:12, fontWeight:600 }}>{n.subject}</div>
                  <div style={{ fontSize:10, color:"var(--text-secondary,#666)", marginTop:2 }}>{n.date}{n.employee?` · ${n.employee}`:(n.author?` · ${n.author}`:"")}</div></div>
              </div>
              <div style={{ fontSize:12, color:"var(--text-secondary,#666)", lineHeight:1.5 }}>{n.note}</div>
              {linked&&<div style={{ fontSize:10, color:CY, marginTop:6 }}>⟳ Also linked to master file: {linked}</div>}
            </div>
          );})):<div style={{ color:"var(--text-secondary,#666)", fontSize:12, padding:"20px 0", textAlign:"center" }}>No file notes recorded.</div>}
        </div>
      );

      case "archive": {
        // Archiving register — box-numbered archived records (record_type = 'Archiving')
        const archived = safeItems.filter(si=>si.recordType==="Archiving");
        return (
          <div>
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
              <div style={{ fontSize:12, fontWeight:500 }}>Archiving register</div>
              <button style={s.btn(true)} onClick={()=>setModal("safeItem")}>＋ Add archive entry</button>
            </div>
            {archived.length>0?(
              <Tbl cols={[{l:"Item",w:"26%"},{l:"Description",w:"20%"},{l:"Location",w:"18%"},{l:"Box no.",w:"12%"},{l:"Date archived",w:"14%"},{l:"Authorised by",w:"10%"}]}
                rows={archived.map(si=>(
                  <tr key={si.id} style={{ borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)" }}>
                    <td style={{ ...s.td, fontWeight:500 }}>{si.item}</td>
                    <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{si.description||"—"}</td>
                    <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{si.location||"—"}</td>
                    <td style={{ ...s.td, color:"var(--text-secondary,#666)", fontFamily:"monospace", fontSize:10 }}>{si.boxNumber||"—"}</td>
                    <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{si.deposited}</td>
                    <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{si.auth}</td>
                  </tr>
                ))}
              />
            ):<div style={{ color:"var(--text-secondary,#666)", fontSize:12, padding:"20px 0", textAlign:"center" }}>No archiving records. Items marked as "Archiving" in Safe custody appear here.</div>}
          </div>
        );
      }

      case "safe": {
        return (
          <div>
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
              <div style={{ fontSize:12, fontWeight:500 }}>Safe custody &amp; archiving register</div>
              <button style={s.btn(true)} onClick={()=>setModal("safeItem")}>＋ Add item</button>
            </div>
            {safeItems.length>0?(
              <Tbl cols={[{l:"Type",w:"12%"},{l:"Item",w:"22%"},{l:"Location",w:"18%"},{l:"Box no.",w:"10%"},{l:"Deposited",w:"11%"},{l:"Retrieved",w:"11%"},{l:"Authorised by",w:"12%"},{l:"Status",w:"9%"}]}
                rows={safeItems.map(si=>(
                  <tr key={si.id} style={{ borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)", background:si.retrieved?"var(--bg-secondary,#f9f9f9)":"transparent" }}>
                    <td style={s.td}><Badge label={si.recordType||"Safe custody"} colors={si.recordType==="Archiving"?{bg:"#EEF0FB",color:"#3C3489"}:{bg:"#E6F7FB",color:"#0077A8"}} /></td>
                    <td style={{ ...s.td, fontWeight:500 }}>{si.item}{si.description&&<span style={{ display:"block", fontSize:10, fontWeight:400, color:"var(--text-secondary,#999)" }}>{si.description}</span>}</td>
                    <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{si.location||"—"}</td>
                    <td style={{ ...s.td, color:"var(--text-secondary,#666)", fontFamily:"monospace", fontSize:10 }}>{si.boxNumber||"—"}</td>
                    <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{si.deposited}</td>
                    <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{si.retrieved||"—"}</td>
                    <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{si.auth}</td>
                    <td style={s.td}><Badge label={si.retrieved?"Out":"Held"} colors={si.retrieved?{bg:"#F1EFE8",color:"#888"}:{bg:"#EAF3DE",color:"#27500A"}} /></td>
                  </tr>
                ))}
              />
            ):<div style={{ color:"var(--text-secondary,#666)", fontSize:12, padding:"20px 0", textAlign:"center" }}>No safe custody or archiving items recorded.</div>}

            <div style={{ display:"flex", justifyContent:"space-between", margin:"18px 0 10px" }}>
              <div style={{ fontSize:12, fontWeight:500 }}>Movements log</div>
              <button style={s.btn(true)} onClick={()=>setModal("safeMovement")}>＋ Log movement</button>
            </div>
            {safeMovements.length>0?(
              <Tbl cols={[{l:"Date",w:"16%"},{l:"Action",w:"20%"},{l:"Requested by",w:"22%"},{l:"Reason",w:"42%"}]}
                rows={safeMovements.map(mv=>(
                  <tr key={mv.id} style={{ borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)" }}>
                    <td style={{ ...s.td, color:"var(--text-secondary,#666)" }}>{mv.date}</td>
                    <td style={s.td}><Badge label={mv.action} colors={/remov/i.test(mv.action)?{bg:"#FAEEDA",color:"#633806"}:/return|deposit/i.test(mv.action)?{bg:"#EAF3DE",color:"#27500A"}:{bg:"#eee",color:"#666"}} /></td>
                    <td style={{ ...s.td, fontWeight:500 }}>{mv.requestedBy}</td>
                    <td style={{ ...s.td, color:"var(--text-secondary,#666)", whiteSpace:"normal", lineHeight:1.3 }}>{mv.reason}</td>
                  </tr>
                ))}
              />
            ):<div style={{ color:"var(--text-secondary,#666)", fontSize:12, padding:"14px 0", textAlign:"center" }}>No movements logged.</div>}
          </div>
        );
      }

      case "compliance": return (
        <div>
          <div style={{ fontSize:12, fontWeight:500, marginBottom:12 }}>Compliance register — {entity.name}</div>
          <div style={s.g2}>
            <div style={s.card}>
              <div style={s.cardT}>Compliance status</div>
              {[["Risk rating",entity.risk],["Last periodic review","14/03/2024"],["Next review due",entity.risk==="High"?"18/08/2025":entity.risk==="Very High"?"12/07/2025":"14/09/2025"],["MLRO","Colette Grisdale"],["Compliance officer","Colette Grisdale"],["KYC status",entity.risk==="High"?"Issues outstanding":"Current"],["Worldcheck","Last screened 14/07/2025"],["PEP status","No PEP identified"],["SOF status","Documented"]].map(([k,v])=>(
                <div key={k} style={s.dRow}><span style={s.dKey}>{k}</span><span style={{ ...s.dVal, color:v.includes("outstanding")?"#EF4444":v.includes("overdue")?"#EF4444":undefined }}>{v}</span></div>
              ))}
            </div>
            <div style={s.card}>
              <div style={s.cardT}>Open compliance cases</div>
              {entity.risk==="High"||entity.risk==="Very High"?(
                <div>
                  <div style={{ background:"#FAEEDA", borderRadius:6, padding:"8px 12px", fontSize:11, color:"#633806", marginBottom:8 }}>
                    ⚠️ {entity.risk==="Very High"?"Sanctions match open — MLRO review required":"EDD documentation outstanding — review overdue"}
                  </div>
                  <div style={{ fontSize:11, color:"var(--text-secondary,#666)", marginBottom:6 }}>Open cases: {entity.risk==="Very High"?2:1}</div>
                  <button style={s.btn(true)} onClick={()=>onNav&&onNav("compliance")}>View in compliance module ↗</button>
                </div>
              ):<div style={{ fontSize:12, color:"#4CAF7D" }}>✓ No open compliance cases</div>}
            </div>
          </div>
        </div>
      );

      case "registers": return (
        <div>
          <div style={{ fontSize:12, fontWeight:500, marginBottom:4 }}>Generate registers</div>
          <div style={{ fontSize:11, color:"var(--text-secondary,#666)", marginBottom:14 }}>Select a register, choose output format, and download. All registers are generated from live entity data.</div>
          {[
            "Company information sheet — detailed",
            "Company information sheet — summary",
            "Register of members",
            "Register of transfers",
            "Register of issuances",
            "Register of directors",
            "Register of secretaries",
            "Register of charges",
            "Register of auditors",
            "Register of managers",
            "Register of directors' shareholdings",
          ].map(r=>(
            <div key={r} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 0", borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)" }}>
              <span style={{ fontSize:12 }}>{r}</span>
              <div style={{ display:"flex", gap:6 }}>
                <button style={{ ...s.btn(false), fontSize:10 }} onClick={printRegister}>Word ↗</button>
                <button style={{ ...s.btn(false), fontSize:10 }} onClick={exportRegister}>Excel ↗</button>
                <button style={{ ...s.btn(true), fontSize:10 }} onClick={printRegister}>PDF ↗</button>
              </div>
            </div>
          ))}
          <div style={{ marginTop:16, padding:14, background:"var(--bg-secondary,#f9f9f9)", borderRadius:8 }}>
            <div style={{ fontSize:12, fontWeight:600, marginBottom:8 }}>Structure chart</div>
            <div style={{ fontSize:11, color:"var(--text-secondary,#666)", marginBottom:10 }}>Generate a structure chart showing ownership, control, and relationships for {entity.name}.</div>
            <div style={{ display:"flex", gap:6 }}>
              <button style={{ ...s.btn(false), fontSize:10 }} onClick={printRegister}>Word ↗</button>
              <button style={{ ...s.btn(false), fontSize:10 }} onClick={exportRegister}>Excel ↗</button>
              <button style={{ ...s.btn(true), fontSize:10 }} onClick={printRegister}>PDF ↗</button>
            </div>
          </div>
        </div>
      );

      case "egaming": {
        const entity = ents.find(e=>e.id===sel);
        return (
          <div>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:14 }}>
              <div>
                <div style={{ fontSize:13, fontWeight:600, marginBottom:2 }}>eGaming & GSC licence</div>
                <div style={{ fontSize:11, color:"var(--text-secondary,#666)" }}>Gambling Supervision Commission — Isle of Man</div>
              </div>
              <button style={{ padding:"5px 14px", borderRadius:5, border:"none", background:"#00C4CC", color:"#fff", fontSize:11, cursor:"pointer" }} onClick={()=>setModal("gaming")}>Update licence data</button>
            </div>

            {/* Licence summary */}
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:14 }}>
              <div style={{ background:"var(--bg-secondary,#f9f9f9)", borderRadius:8, padding:14 }}>
                <div style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.4px", color:"#888", marginBottom:10 }}>Licence details</div>
                {[
                  ["Licence reference", entity?.regNo||"—"],
                  ["Licence type", entity?.id===13?"B2C — Casino":"B2B — Platform supply"],
                  ["Status", entity?.id===13?"Application — stage 2":"Live"],
                  ["Issued", entity?.id===13?"Pending":"01/06/2023"],
                  ["Expiry", entity?.id===13?"Pending":"31/05/2026"],
                  ["Annual return due", entity?.id===13?"N/A":"30/11/2025"],
                ].map(([k,v])=>(
                  <div key={k} style={{ display:"flex", justifyContent:"space-between", padding:"5px 0", borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)", fontSize:12 }}>
                    <span style={{ color:"var(--text-secondary,#666)" }}>{k}</span>
                    <span style={{ fontWeight:500 }}>{v}</span>
                  </div>
                ))}
              </div>
              <div style={{ background:"var(--bg-secondary,#f9f9f9)", borderRadius:8, padding:14 }}>
                <div style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.4px", color:"#888", marginBottom:10 }}>GSC obligations</div>
                {[
                  ["AML/CFT policy",       "Current",    "#4CAF7D"],
                  ["Responsible gambling", "Current",    "#4CAF7D"],
                  ["Technical standards",  entity?.id===13?"Pending":"Current", entity?.id===13?"#F59E0B":"#4CAF7D"],
                  ["Suitability — directors","Current",  "#4CAF7D"],
                  ["Financial resources",  "Confirmed",  "#4CAF7D"],
                  ["RNG certification",    entity?.id===13?"Pending":"Current", entity?.id===13?"#F59E0B":"#4CAF7D"],
                ].map(([k,v,c])=>(
                  <div key={k} style={{ display:"flex", justifyContent:"space-between", padding:"5px 0", borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)", fontSize:12 }}>
                    <span style={{ color:"var(--text-secondary,#666)" }}>{k}</span>
                    <span style={{ fontWeight:600, color:c }}>{v}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Application checklist if applicable */}
            {entity?.id===13&&(
              <div style={{ background:"var(--bg-secondary,#f9f9f9)", borderRadius:8, padding:14 }}>
                <div style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.4px", color:"#888", marginBottom:10 }}>GSC application checklist</div>
                {[
                  { step:"Operator information form (OIF)",            status:"Complete" },
                  { step:"Business plan — 3 year projection",          status:"Complete" },
                  { step:"AML/CFT policy",                             status:"Complete" },
                  { step:"Responsible gambling policy",                status:"Complete" },
                  { step:"Suitability — all directors",                status:"In progress" },
                  { step:"System technical standards certification",   status:"Pending" },
                  { step:"RNG / game certification",                   status:"Pending" },
                  { step:"Financial resources evidence",               status:"Complete" },
                  { step:"IT & security assessment",                   status:"Pending" },
                  { step:"GSC suitability decision",                  status:"Pending" },
                ].map((c,i)=>(
                  <div key={i} style={{ display:"flex", gap:10, padding:"7px 0", borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)", alignItems:"center" }}>
                    <div style={{ width:22, height:22, borderRadius:"50%", background:c.status==="Complete"?"#4CAF7D":c.status==="In progress"?"#00C4CC":"#f0f0f0", color:c.status==="Complete"||c.status==="In progress"?"#fff":"#aaa", display:"flex", alignItems:"center", justifyContent:"center", fontSize:10, fontWeight:700, flexShrink:0 }}>
                      {c.status==="Complete"?"✓":i+1}
                    </div>
                    <div style={{ flex:1, fontSize:12 }}>{c.step}</div>
                    <span style={{ display:"inline-block", padding:"2px 8px", borderRadius:20, fontSize:10, fontWeight:600, background:c.status==="Complete"?"#EAF3DE":c.status==="In progress"?"#E6F7FB":"#f0f0f0", color:c.status==="Complete"?"#27500A":c.status==="In progress"?"#0077A8":"#aaa" }}>{c.status}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      }

      default: return <div style={{ color:"var(--text-secondary,#666)", fontSize:12, padding:"20px 0", textAlign:"center" }}>Content for {tab} tab.</div>;
    }
  };

  // Turn "DD/MM/YYYY" as typed into the ISO date the database expects, and
  // leave a blank as null rather than sending an empty string.
  const toISO = (v) => {
    if (!v || !String(v).trim()) return null;
    const t = String(v).trim();
    const uk = t.match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})$/);
    if (uk) return `${uk[3]}-${uk[2].padStart(2,"0")}-${uk[1].padStart(2,"0")}`;
    if (/^\d{4}-\d{2}-\d{2}$/.test(t)) return t;
    return null;
  };
  const num = (v) => (v === "" || v == null ? null : Number(String(v).replace(/[^0-9.\-]/g, "")) || null);

  // A save handler per register. Only registers listed here can be saved; the
  // rest keep a disabled Save so nothing looks writable when it is not.
  // `sel` is the database id once the live portfolio has loaded. In preview mode
  // it is a demo id, so writing is not offered at all.
  const entityDbId = (isConfigured && liveEnts && sel != null) ? sel : null;

  // Register actions — resign, update, remove, close. All fifteen of these
  // functions had API wrappers and no buttons, so every register could be
  // added to and never changed.
  const [act, setAct]         = useState(null);
  const [actF, setActF]       = useState({});
  const [actId, setActId]     = useState(null);
  const [actSubj, setActSubj] = useState("");
  const [actMsg, setActMsg]   = useState("");
  const [actBusy, setActBusy] = useState(false);

  const openAct = (spec, id, subject, seed) => {
    setAct(spec); setActId(id); setActSubj(subject || "");
    setActF(seed || {}); setActMsg("");
  };

  const runAct = async () => {
    setActBusy(true); setActMsg("");
    const v = actF;
    let r;
    try {
      if (act === "officerResign")     r = await EW.officerResign(actId, toISO(v.resigned));
      if (act === "officerUpdate")     r = await EW.officerUpdate(actId, v);
      if (act === "uboUpdate")         r = await EW.uboUpdate(actId, v);
      if (act === "uboRemove")         r = await EW.uboRemove(actId, v.reason);
      if (act === "shareholderRemove") r = await EW.shareholderRemove(actId, v.reason);
      if (act === "signatoryRemove")   r = await EW.signatoryRemove(actId, toISO(v.toDate));
      if (act === "dividendPay")       r = await EW.dividendPay(actId, toISO(v.paidDate));
      if (act === "safeRetrieve")      r = await EW.safeItemRetrieve(actId,
                                              toISO(v.retrievedDate), v.authorisedBy);
      if (act === "chargeSatisfy")     r = await EW.chargeSatisfy(actId, toISO(v.satisfiedDate));
      if (act === "bankClose")         r = await EW.bankClose(actId, toISO(v.closedDate));
      if (act === "assetRevalue")      r = await EW.assetRevalue(actId, Number(v.value),
                                              toISO(v.valuationDate));
      if (act === "serviceSet")        r = await EW.serviceSet(entityDbId, v.service,
                                              String(v.active).toLowerCase() === "yes");
      if (act === "profileUpdate")     r = await EW.profileUpdate(entityDbId, v);
      // db/101: validated against the classification list rather than free
      // text, and refuses a classification needing a GIIN without one.
      if (act === "classification")    r = await EA.entityClassificationSet(entityDbId,
                                              v.fatcaClass, v.crsClass, v.giin);
      if (act === "responsibilities")  r = await EW.responsibilitiesSet(entityDbId, v);
      if (act === "entityClose")       r = await EW.entityClose(entityDbId, v.reason,
                                              toISO(v.closedDate));
      if (act === "caseload")          r = await EW.reassignCaseload(v.fromName, v.toName,
                                              v.roleField);
    } catch (e) {
      r = { ok: false, live: true, error: String((e && e.message) || e) };
    }
    setActBusy(false);
    if (r && r.ok) {
      setAct(null); setActF({}); setActMsg("");
      setDetVersion((n) => n + 1);   // reload the registers
      return;
    }
    if (r && r.live === false) { setActMsg("Not signed in — that cannot be saved."); return; }
    setActMsg((r && r.error) || "That could not be saved.");
  };

  const modalSaves = {
    // Aliases. The buttons open 'bank', 'fileNote' and 'safeItem'; the
    // handlers below are keyed 'account', 'filenote' and 'safeitem'. The
    // mismatch made three working registers report "the write function is not
    // built" — reported by a tester within minutes of opening the module, and
    // invisible to every check in the suite.

    // Creating a client. Found missing by the wiring audit: every register
    // worked but nothing could create the entity they hang off.
    // Creating a client. Found missing by the wiring audit: every register
    // worked, but nothing could create the entity they all hang off.
    newEntity: (v) => DW.eaEntityCreate({
      name: v["Entity name"],
      entityClass: "client",
      entityType: v["Entity type"],
      jurisdiction: v["Jurisdiction"],
      regNo: v["Registration number"],
      incorporationDate: toISO(v["Incorporated"] || v["Incorporation date"]),
      yearEnd: v["Year end"],
      businessActivity: v["Principal activity"] || v["Business activity"],
      riskRating: v["Risk rating"],
      administrator: v["Administrator"],
      office: v["Office"],
    }),
    director: (v) => EW.officerAdd(entityDbId, {
      name: v["Full legal name"], role: v["Role"],
      appointed: toISO(v["Date appointed"]), dob: toISO(v["Date of birth"]),
      nationality: v["Nationality"],
      // db/105: the parts, not one box. The function composes the single line
      // from them, so everything already reading `address` keeps working.
      line1: v["Address line 1"], line2: v["Address line 2"],
      city: v["City / town"], country: v["Country"], postcode: v["Postcode"],
    }),
    shareholder: (v) => EW.shareholderAdd(entityDbId, {
      name: v["Shareholder name"], shareClass: v["Share class"],
      shares: num(v["Number of shares"]), heldFrom: toISO(v["Registration date"]),
    }),
    ubo: (v) => EW.uboAdd(entityDbId, {
      name: v["Full legal name"] || v["Name"], role: v["Role"],
      dob: toISO(v["Date of birth"]), nationality: v["Nationality"],
      ownershipPct: num(v["Ownership %"] || v["Ownership percentage"]),
      natureOfControl: v["Nature of control"],
    }),
    account: (v) => EW.bankAdd(entityDbId, {
      bank: v["Bank"] || v["Bank name"], accountName: v["Account name"],
      number: v["Account number"], ccy: v["Currency"],
      resolutionDate: toISO(v["Board resolution date"] || v["Resolution date"]),
    }),
    signatory: (v) => EW.signatoryAdd(entityDbId, {
      name: v["Name"] || v["Full legal name"], category: v["Category"],
      class: v["Class"], fromDate: toISO(v["From"] || v["From date"]),
    }),
    charge: (v) => EW.chargeAdd(entityDbId, {
      chargee: v["Chargee"] || v["Chargee name"], chargeType: v["Charge type"],
      amount: num(v["Amount"]), ccy: v["Currency"],
      registeredDate: toISO(v["Date registered"] || v["Registration date"]),
    }),
    asset: (v) => EW.assetAdd(entityDbId, {
      description: v["Description"] || v["Asset description"],
      acquiredDate: toISO(v["Date acquired"]), value: num(v["Value"]),
      ccy: v["Currency"], notes: v["Notes"],
    }),
    dividend: (v) => EW.dividendAdd(entityDbId, {
      shareClass: v["Share class"], name: v["Shareholder"] || v["Name"],
      requestedDate: toISO(v["Date requested"] || v["Date declared"]),
      perShare: num(v["Per share"] || v["Amount per share"]), notes: v["Notes"],
    }),
    meeting: (v) => EW.meetingAdd(entityDbId, {
      meetingType: v["Meeting type"], meetingDate: toISO(v["Date"] || v["Meeting date"]),
      notes: v["Agenda"] || v["Notes"],
    }),
    address: (v) => EW.addressAdd(entityDbId, {
      addressType: v["Address type"], address: v["Address"],
      fromDate: toISO(v["Effective from"] || v["From"]),
      line1: v["Address line 1"], line2: v["Address line 2"],
      city: v["City / town"], country: v["Country"], postcode: v["Postcode"],
    }),
    filenote: (v) => EW.fileNoteAdd(entityDbId, v["Note"] || v["File note"], toISO(v["Date"])),
    safeitem: (v) => EW.safeItemAdd(entityDbId, {
      item: v["Item"] || v["Description"], depositedDate: toISO(v["Date deposited"]),
      authorisedBy: v["Authorised by"],
    }),
  
    // These three are the same handlers under the names the buttons use.
    bank:      (v) => modalSaves.account(v),
    fileNote:  (v) => modalSaves.filenote(v),
    safeItem:  (v) => modalSaves.safeitem(v),
};

  const modalForms = {
    director: { title:"Appoint officer / trustee", fields:[
      {label:"Full legal name",placeholder:"Full name",full:true},
      {label:"Role",type:"select",opts:["Director","Director / UBO","Alternate Director","Secretary","Trustee","Settlor","Beneficiary","Protector","Manager","Attorney"]},
      {label:"Date appointed",placeholder:"DD/MM/YYYY"},
      {label:"Date of birth",placeholder:"DD/MM/YYYY"},
      {label:"Nationality",placeholder:"", type:"nationality"},
      {label:"Address line 1",placeholder:"Building and street",full:true},
             {label:"Address line 2",placeholder:"", required:false},
             {label:"City / town",placeholder:""},
             {label:"Postcode",placeholder:"", required:false},
             {label:"Country",placeholder:"", type:"country"},
    ]},
    shareholder: { title:"Register share transfer / issuance", fields:[
      {label:"Shareholder name",placeholder:"Full legal name",full:true},
      {label:"Type",type:"select",opts:["Individual","Corporate","Trust"]},
      {label:"Number of shares",placeholder:"0",type:"number"},
      {label:"Share class",type:"select",opts:["Ordinary","Preference","Redeemable","Units","A shares","B shares"]},
      {label:"Nominal value",placeholder:"£1"},
      {label:"Amount paid up",placeholder:"£0.00"},
      {label:"Registration date",placeholder:"DD/MM/YYYY"},
      {label:"Transaction type",type:"select",opts:["New issuance","Transfer in","Transfer out","Redemption"]},
    ]},
    address: { title:"Add address", fields:[
      {label:"Address type",type:"select",opts:["Registered office","Correspondence","Business address","Mailing address","Property address","Other"]},
      {label:"Address line 1",placeholder:"Building and street",full:true},
             {label:"Address line 2",placeholder:"", required:false},
             {label:"City / town",placeholder:""},
             {label:"Postcode",placeholder:"", required:false},
             {label:"Country",placeholder:"", type:"country"},
      {label:"Effective from",placeholder:"DD/MM/YYYY"},
      {label:"Effective to (if historical)",placeholder:"DD/MM/YYYY or leave blank"},
    ]},
    bank: { title:"Add bank / broker account", fields:[
      {label:"Bank / broker name",placeholder:"e.g. Barclays Bank",full:true},
      {label:"Account name",placeholder:"e.g. Current account"},
      {label:"Account number",placeholder:"****"},
      {label:"Currency",type:"select",opts:["GBP","USD","EUR","Other"]},
      {label:"Board resolution date",placeholder:"DD/MM/YYYY"},
      {label:"Date closed",placeholder:"DD/MM/YYYY or leave blank"},
    ]},
    charge: { title:"Register charge / security interest", fields:[
      {label:"Chargee / lender",placeholder:"Name",full:true},
      {label:"Type",type:"select",opts:["Fixed charge","Floating charge","Debenture","Mortgage","Pledge"]},
      {label:"Amount",placeholder:"0.00"},
      {label:"Currency",type:"select",opts:["GBP","USD","EUR"]},
      {label:"Date registered",placeholder:"DD/MM/YYYY"},
      {label:"Date discharged",placeholder:"DD/MM/YYYY or leave blank"},
    ]},
    asset: { title:"Add asset", fields:[
      {label:"Description",placeholder:"e.g. Commercial property — Manchester",full:true},
      {label:"Date of acquisition",placeholder:"DD/MM/YYYY"},
      {label:"Last valuation date",placeholder:"DD/MM/YYYY"},
      {label:"Purchase / current value",placeholder:"0.00"},
      {label:"Currency",type:"select",opts:["GBP","USD","EUR"]},
      {label:"Notes",placeholder:"Any relevant notes",full:true,type:"textarea"},
    ]},
    dividend: { title:"Record dividend", fields:[
      {label:"Share class",type:"select",opts:["Ordinary","Preference","A shares","B shares"]},
      {label:"Recipient",placeholder:"Name"},
      {label:"Date requested",placeholder:"DD/MM/YYYY"},
      {label:"Date paid",placeholder:"DD/MM/YYYY"},
      {label:"Dividend per share",placeholder:"£0.00"},
      {label:"Notes",placeholder:"Notes",full:true},
    ]},
    foreignReg: { title:"Add foreign registration", fields:[
      {label:"Country",placeholder:"", type:"country"},
      {label:"Last annual return",placeholder:"DD/MM/YYYY"},
      {label:"Next annual return",placeholder:"DD/MM/YYYY"},
      {label:"Last accounts",placeholder:"DD/MM/YYYY"},
      {label:"Next accounts due",placeholder:"DD/MM/YYYY"},
      {label:"Notes",placeholder:"Notes",full:true},
    ]},
    relation: { title:"Add relation", fields:[
      {label:"Full legal name",placeholder:"Full name",full:true},
      {label:"Role / connection",type:"select",opts:["Beneficial owner","Director","Shareholder","Trustee","Settlor","Beneficiary","Attorney","Protector","Introducer","Service provider","Customer","Supplier","Designated Officer","Operations Manager","Data Protection Officer","MLRO","DMLRO","AML/CFT Compliance Officer","Nominated AML/CFT Compliance Officer","Other"]},
      {label:"Date of birth",placeholder:"DD/MM/YYYY"},
      {label:"Nationality",placeholder:"", type:"nationality"},
      {label:"Also linked to (other entities)",placeholder:"Leave blank or enter entity names",full:true},
    ]},
    meeting: { title:"Schedule meeting", fields:[
      {label:"Meeting type",type:"select",opts:["Board meeting","Shareholder meeting","Trustee meeting","Annual general meeting","Extraordinary general meeting","Written resolution"]},
      {label:"Date",placeholder:"DD/MM/YYYY"},
      {label:"Location / platform",placeholder:"e.g. Douglas, IOM or Zoom"},
      {label:"Attendees",placeholder:"Names of attendees",full:true},
      {label:"Agenda items",placeholder:"Agenda summary",full:true,type:"textarea"},
    ]},
    fileNote: { title:"Add file note", fields:[
      {label:"Subject",placeholder:"Brief subject",full:true},
      {label:"Date",placeholder:"DD/MM/YYYY"},
      {label:"Note",placeholder:"Note content",full:true,type:"textarea"},
    ]},
    safeItem: { title:"Add safe custody item", fields:[
      {label:"Item description",placeholder:"e.g. Original certificate of incorporation",full:true},
      {label:"Date deposited",placeholder:"DD/MM/YYYY"},
      {label:"Authorised by",placeholder:"Name"},
    ]},
    statutory: { title:"Edit statutory data", fields:[
      {label:"Registration number",placeholder:entity?.regNo},
      {label:"Date incorporated",placeholder:entity?.incorporated},
      {label:"Year end",placeholder:entity?.yearEnd},
      {label:"Principal currency",type:"select",opts:["GBP","USD","EUR"]},
      {label:"Tax status",type:"select",opts:["Tax exempt","Tax resident — IOM","Tax resident — UK","Tax resident — Malta","Tax resident — Cayman","Other"]},
      {label:"FATCA classification",type:"select",opts:["Passive NFE","Active NFE","Foreign Financial Institution","Deemed Compliant FFI","Exempt Beneficial Owner"]},
      {label:"CRS classification",type:"select",opts:["Passive NFE","Active NFE","Reporting Financial Institution","Non-Reporting Financial Institution"]},
    ]},
  };

  return (
    <div style={s.wrap}>
      {outMsg && (
        <div style={{ margin:"0 20px 10px", padding:"9px 12px", borderRadius:7, fontSize:11.5,
                      lineHeight:1.6, background:"#FCEBEB", border:"0.5px solid #f0c9c9", color:"#A32D2D" }}>
          {outMsg}
        </div>
      )}

      {/* Header */}
      <div style={s.hdr}>
        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
          <div style={s.logo}>Entity Admin</div>
          {/* Where these records came from. The preview dataset mirrors the
              seeded database exactly, so without saying so there is no way to
              tell whether the page is reading Supabase or falling back. */}
          {liveEnts && liveEnts.length ? (
            <span title="Reading live records from the database"
                  style={{ fontSize:10, fontWeight:600, padding:"3px 9px", borderRadius:20,
                           background:"#E7F4EF", color:"#1F6F54", border:"0.5px solid #bfe0d2" }}>
              ● Live data · {liveEnts.length} entities
            </span>
          ) : (
            <span title={isConfigured
                    ? "Signed in, but the database returned no records — the grants may not be in place"
                    : "Not signed in, so the database cannot be read"}
                  style={{ fontSize:10, fontWeight:600, padding:"3px 9px", borderRadius:20,
                           background:"#FDF4DC", color:"#7B4F1D", border:"0.5px solid #E5CE9A" }}>
              ● {isConfigured ? "No records returned" : "Preview data"}
            </span>
          )}
        </div>
      </div>

      <div style={s.body}>
        {/* Search-driven entity admin — list panel removed per UX review */}
        <div style={{...s.detail, flex:1}}>
          <div style={{ padding:"12px 20px", borderBottom:"0.5px solid var(--border-tertiary,#e5e5e5)", display:"flex", gap:8, alignItems:"center", flexWrap:"wrap" }}>
            <div style={{ ...s.sw, flex:1, maxWidth:520, minWidth:240 }}>
              <i className="ti ti-search" style={{ fontSize:13, color:"var(--text-secondary,#666)" }} />
              <input
                list="ea-entity-list"
                style={s.swI}
                placeholder="Search for an entity by name or reference…"
                value={search}
                onChange={e=>{
                  const v=e.target.value;
                  setSearch(v);
                  const m=filtered.find(en=>en.name===v||en.ref===v)||ents.find(en=>en.name===v||en.ref===v);
                  if(m){ setSel(m.id); setTab("overview"); }
                }}
              />
              <datalist id="ea-entity-list">{filtered.flatMap(e=>{
                const mark=(e.entityClass||"client")==="group"?" · Internal":"";
                return [<option key={"n"+e.id} value={e.name}>{e.ref+mark}</option>,<option key={"r"+e.id} value={e.ref}>{e.name+mark}</option>];
              })}</datalist>
            </div>
            {entity&&<button style={s.btn(false)} onClick={()=>{ setSel(null); setSearch(""); }}>Clear ✕</button>}
            <button style={s.btn(true)} onClick={()=>setModal("newEntity")}>＋ New entity</button>
          </div>
          {entity?(
            <>
              <div style={s.detHdr}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                  <div>
                    <div style={{ fontSize:16, fontWeight:600, marginBottom:4 }}>{entity.name}</div>
                    <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                      {/* First in the row deliberately. Demo records sit in the
                          same register as real clients, and the realistic
                          failure is a real filing or real time recorded against
                          sample data — so this has to be read before anything
                          else on the entity. */}
                      {(entity.is_demo || !liveEnts || !liveEnts.length) && (
                        <Badge label="DEMO DATA — NOT A REAL CLIENT"
                               colors={{ bg:"#FDF4DC", color:"#7B4F1D" }} />
                      )}
                      {/* WHY it is demo data, which is the part that was
                          missing. Saying "this entity is not loaded from the
                          database" on every Save and never saying why sends
                          somebody looking at the entity when the fault is in a
                          call they cannot see. */}
                      {loadError && (
                        <span style={{ fontSize:10.5, color:"#8A1F11",
                                       background:"#FDECEA",
                                       border:"0.5px solid #F5C6C2",
                                       borderRadius:5, padding:"3px 9px" }}>
                          Live entities could not be loaded — {loadError}
                        </span>
                      )}
                      <Badge label={entity.ref} colors={{ bg:"var(--bg-secondary,#f9f9f9)", color:"var(--text-secondary,#666)" }} />
                      {(entity.entityClass||"client")==="group"
                        ? <Badge label="Internal — Affinity Group" colors={{ bg:"#EAF0FB", color:"#274690" }} />
                        : <Badge label="Client entity" colors={{ bg:"#F0F7F0", color:"#2F6B3A" }} />}
                      <Badge label={jurShort[entity.jur]||entity.jur} colors={officeColors[entity.jur]} />
                      <Badge label={entity.type} colors={{ bg:"var(--bg-secondary,#f9f9f9)", color:"var(--text-secondary,#666)" }} />
                      <Badge label={entity.status} colors={statusBadge(entity.status)} />
                      {entity.risk && entity.risk!=="—" && <Badge label={entity.risk+" risk"} colors={riskColors[entity.risk]} />}
                    </div>
                    {entityDbId && (
                      <div style={{ display:"flex", gap:6, marginTop:8, flexWrap:"wrap" }}>
                        <button style={s.mini} onClick={()=>openAct("profileUpdate", null, entity.name,
                          { regNo:entity.regNo, yearEnd:entity.yearEnd,
                            businessActivity:entity.principalActivity,
                            riskRating:entity.risk, adminStatus:entity.status })}>
                          Edit entity
                        </button>
                        <button style={s.mini} onClick={()=>openAct("classification", null, entity.name)}>
                          FATCA / CRS
                        </button>
                        <button style={s.mini} onClick={()=>openAct("responsibilities", null, entity.name,
                          { administrator:entity.administrator, manager:entity.manager,
                            leadDirector:entity.leadDirector, accountant:entity.accountant })}>
                          Responsibilities
                        </button>
                        <button style={s.mini} onClick={()=>openAct("caseload", null, "")}>
                          Reassign caseload
                        </button>
                        <button style={s.mini}
                                title="A satisfied charge stays on the register with its date — whether security was in place on a given date is what gets asked in a transaction"
                                onClick={()=>{
                                  const id = window.prompt("Charge id to satisfy? (shown in the Charges tab)");
                                  if (id) openAct("chargeSatisfy", Number(id), "Charge " + id);
                                }}>
                          Satisfy a charge
                        </button>
                        <button style={s.mini}
                                title="The account stays on the register with a closing date — which account was in use when a payment was made comes up later"
                                onClick={()=>{
                                  const id = window.prompt("Bank account id to close? (shown in the Bank accounts tab)");
                                  if (id) openAct("bankClose", Number(id), "Account " + id);
                                }}>
                          Close an account
                        </button>
                        <button style={s.mini}
                                title="A valuation with no date cannot be judged as current or stale"
                                onClick={()=>{
                                  const id = window.prompt("Asset id to revalue? (shown in the Assets tab)");
                                  if (id) openAct("assetRevalue", Number(id), "Asset " + id);
                                }}>
                          Revalue an asset
                        </button>
                        <button style={s.mini}
                                title="The valid FATCA and CRS codes and what each means for reporting"
                                onClick={async()=>{
                                  const r = await EA.classificationTypes(null);
                                  if (!r || !r.live) { window.alert("Not signed in."); return; }
                                  const rows = r.data || [];
                                  const by = (reg) => rows.filter(x=>x.regime===reg)
                                    .map(x=>`  ${x.code.padEnd(7)} ${x.name}` +
                                            (x.reportable ? "  [REPORTS]" : "") +
                                            (x.needs_giin ? "  [needs GIIN]" : ""))
                                    .join("\n");
                                  window.alert(
                                    "FATCA\n" + by("FATCA") + "\n\nCRS\n" + by("CRS") +
                                    "\n\n[REPORTS] means the entity itself has a reporting " +
                                    "obligation. Passive NFFE and Passive NFE look through to " +
                                    "controlling persons, which is the classification most " +
                                    "holding companies land on.");
                                }}>
                          Classification codes
                        </button>
                        <button style={s.mini}
                                title="Work through the questions that arrive at a classification, and record the answers"
                                onClick={async()=>{
                                  const reg = window.prompt("FATCA or CRS?", "FATCA");
                                  if (!reg) return;
                                  const q = await EA.classificationQuestions(reg.toUpperCase());
                                  if (!q || !q.live) { window.alert("Not signed in."); return; }
                                  const answers = {};
                                  for (const item of (q.data || [])) {
                                    const a = window.prompt(
                                      item.question + "\n\n" + (item.help || "") +
                                      "\n\nAnswer yes, no, or n/a. Cancel to stop.");
                                    if (a === null) return;
                                    answers[item.code] = a;
                                  }
                                  const concl = window.prompt(
                                    "Which classification does that arrive at?\n\n" +
                                    "This is your judgement, not the system's — the answers " +
                                    "above are recorded beside it so it can be defended later.");
                                  if (!concl) return;
                                  const why = window.prompt("Why, in a sentence?");
                                  const r = await EA.classificationAssess(entityDbId,
                                              reg.toUpperCase(), answers, concl.toUpperCase(), why);
                                  window.alert(r && r.ok
                                    ? "Assessment recorded and the classification applied."
                                    : (r && r.error) || "That could not be recorded.");
                                }}>
                          Classify (guided)
                        </button>
                        <button style={s.mini}
                                title="Every reportable account, holder and controlling person — and what is missing"
                                onClick={async()=>{
                                  const reg = window.prompt("FATCA or CRS?", "FATCA");
                                  if (!reg) return;
                                  const pe = window.prompt("Period end (YYYY-MM-DD)?", "2025-12-31");
                                  if (!pe) return;
                                  const [x, rd] = await Promise.all([
                                    EA.fatcaCrsExtract(reg.toUpperCase(), pe, null),
                                    EA.fatcaCrsReadiness(reg.toUpperCase(), pe),
                                  ]);
                                  if (!x || !x.live) { window.alert("Not signed in."); return; }
                                  const rows = x.data || [], r0 = (rd.data || [])[0] || {};
                                  const gaps = rows.filter(r=>r.missing);
                                  window.alert(
                                    reg.toUpperCase() + " extract to " + pe + "\n\n" +
                                    r0.entities + " client entit(ies), " + r0.reportable +
                                    " reportable, " + gaps.length + " row(s) with something missing.\n\n" +
                                    (gaps.length
                                      ? "Nothing can be filed until these are closed:\n" +
                                        [...new Set(gaps.map(g=>g.missing))].slice(0,8).map(m=>"  · "+m).join("\n")
                                      : "Every row is complete.") +
                                    "\n\nThe extract is the content of the return. The file itself " +
                                    "differs by jurisdiction — the IRS takes FATCA XML, and the " +
                                    "Isle of Man, Malta and Cayman portals each publish their own " +
                                    "template.");
                                }}>
                          Reporting extract
                        </button>
                        <button style={s.mini}
                                title="What follows from the classification, and what is missing"
                                onClick={async()=>{
                                  const r = await EA.classificationStatus(null);
                                  if (!r || !r.live) { window.alert("Not signed in."); return; }
                                  const rows = r.data || [];
                                  const gaps = rows.filter(x=>x.gap);
                                  window.alert(
                                    rows.length + " client entit(ies), " + gaps.length +
                                    " with a classification gap" +
                                    (gaps.length
                                      ? ":\n" + gaps.slice(0,15).map(x=>`  ${x.entity_name}: ${x.gap}`).join("\n")
                                      : ". Every entity is classified.") +
                                    "\n\nAn unclassified entity is not reported at all, which is " +
                                    "the failure that does not announce itself.");
                                }}>
                          Classification gaps
                        </button>
                        <button style={s.mini}
                                title="What is recorded as provided — the list feeds billing and could not be read back to check against what is billed"
                                onClick={async()=>{
                                  const r = await EA.eaServices(entityDbId);
                                  if (!r || !r.live) { window.alert("Not signed in."); return; }
                                  const rows = r.data || [];
                                  window.alert(rows.length
                                    ? "Services recorded for " + entity.name + ":\n"
                                      + rows.map(x=>`  ${x.service}${x.active===false?" (inactive)":""}`).join("\n")
                                    : "No services recorded for " + entity.name
                                      + ". Anything provided is not being invoiced for.");
                                }}>
                          Services
                        </button>
                        <button style={{ ...s.mini, color:"#A32D2D", borderColor:"#f0c9c9" }}
                                title="Refused while unbilled time stands against the entity, because closing writes that work off"
                                onClick={()=>openAct("entityClose", null, entity.name)}>
                          Close entity
                        </button>
                      </div>
                    )}
                  </div>
                  <div style={{ display:"flex", gap:6 }}>
                    <button style={s.btn(false)}
                      title="Change the registration number, year end, business activity, risk rating or status"
                      onClick={()=>openAct("profileUpdate", null, entity.name,
                        { regNo: entity.regNo, yearEnd: entity.yearEnd,
                          businessActivity: entity.principalActivity,
                          riskRating: entity.risk, adminStatus: entity.status })}>
                      Edit entity
                    </button>
                    <button style={s.btn(false)} onClick={()=>onNav&&onNav("documents")}
                      title={"Open "+(entity?entity.name:"this entity")+" in Documents"}>Documents ↗</button>
                    <button style={s.btn(true)} onClick={()=>onNav&&onNav("generate")}
                      title="Generate a statutory register document">Generate register ↗</button>
                  </div>
                </div>
              </div>
              <div style={{display:"flex",flex:1,overflow:"hidden"}}>
                <div style={{width:172,minWidth:172,borderRight:"0.5px solid var(--border-tertiary,#e5e5e5)",overflowY:"auto",background:"var(--bg-secondary,#f9f9f9)",flexShrink:0}}>
                  {["Entity","Regulatory","Registers","Filing Obligations","Admin"].map(group=>{
                    const groupTabs=TABS.filter(t=>t.group===group && (!t.gamingOnly || entity?.isGaming));
                    if(groupTabs.length===0) return null;
                    return <div key={group}>
                      <div style={{fontSize:9,fontWeight:600,color:"#aaa",textTransform:"uppercase",letterSpacing:"0.5px",padding:"10px 12px 4px"}}>{group}</div>
                      {groupTabs.map(t=><div key={t.id} onClick={()=>setTab(t.id)} style={{padding:"7px 12px",cursor:"pointer",fontSize:12,borderLeft:`2px solid ${tab===t.id?CY:"transparent"}`,background:tab===t.id?"var(--bg-primary,#fff)":"transparent",color:tab===t.id?"var(--text-primary,#111)":"var(--text-secondary,#666)",fontWeight:tab===t.id?500:400,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{t.label}</div>)}
                    </div>;
                  })}
                </div>
                <div style={{flex:1,overflowY:"auto",padding:"14px 20px"}}>
                  {tab==="fatca"&&<FATCATab entity={entity}/>}
                  {tab==="crs"&&<CRSTab entity={entity}/>}
                  {tab==="substance"&&<SubstanceTab entity={entity}/>}
                  {tab==="structure"&&<div style={{margin:"-20px -24px"}}><EntityChart onNav={onNav}/></div>}
                  {tab==="egaming_reg"&&<div style={{margin:"-14px -20px"}}>
                    <AffinityEGaming entity={entity} onNav={onNav}/>
                    {/* Gaming compliance log — the same register catalogue as Compliance,
                        scoped to this entity, so gaming obligations are logged in context. */}
                    <div style={{ padding:"16px 20px", borderTop:"0.5px solid var(--border-tertiary,#e5e5e5)" }}>
                      <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4, flexWrap:"wrap" }}>
                        <div style={{ fontSize:14, fontWeight:600, color:"#001242" }}>Compliance log</div>
                        <span style={{ fontSize:10.5, color:"#888" }}>{REGISTER_ORDER.length} registers · {entity?.name}</span>
                        <select value={gamingReg} onChange={e=>setGamingReg(e.target.value)}
                          style={{ height:29, padding:"0 8px", fontSize:11.5, border:"0.5px solid #ccc", borderRadius:5, background:"#fff", minWidth:220, marginLeft:"auto" }}>
                          <option value="">All registers</option>
                          {REGISTER_ORDER.map(r=><option key={r} value={r}>{r==="breaches"?"Breach log":COMPLIANCE_REGISTERS[r].label}</option>)}
                        </select>
                      </div>
                      {!gamingReg ? (
                        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(210px,1fr))", gap:8, marginTop:10 }}>
                          {REGISTER_ORDER.map(r=>(
                            <div key={r} onClick={()=>setGamingReg(r)}
                              style={{ background:"var(--bg-primary,#fff)", border:"0.5px solid #e5e5e5", borderRadius:8, padding:"10px 12px", cursor:"pointer" }}>
                              <div style={{ fontSize:11.5, fontWeight:600, color:"#001242" }}>{r==="breaches"?"Breach log":COMPLIANCE_REGISTERS[r].label}</div>
                              <div style={{ fontSize:10, color:"#aaa", marginTop:3 }}>{(COMPLIANCE_REGISTERS[r].cols||[]).slice(0,3).join(" · ")}</div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div style={{ marginTop:10 }}>
                          <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8 }}>
                            <div style={{ fontSize:12.5, fontWeight:600 }}>{gamingReg==="breaches"?"Breach log":COMPLIANCE_REGISTERS[gamingReg].label}</div>
                            <button onClick={()=>setGamingReg("")} style={{ height:26, padding:"0 9px", fontSize:10.5, borderRadius:5, border:"0.5px solid #e5e5e5", background:"transparent", color:"#666", cursor:"pointer" }}>← All registers</button>
                          </div>
                          <table style={{ width:"100%", borderCollapse:"collapse" }}>
                            <thead><tr>{(COMPLIANCE_REGISTERS[gamingReg].cols||[]).map(c=>(
                              <th key={c} style={{ padding:"7px 10px", textAlign:"left", fontSize:10, fontWeight:600, color:"#666", textTransform:"uppercase", letterSpacing:"0.4px", borderBottom:"0.5px solid #e5e5e5" }}>{c}</th>
                            ))}</tr></thead>
                            <tbody>
                              <tr><td colSpan={(COMPLIANCE_REGISTERS[gamingReg].cols||[]).length}
                                style={{ padding:"22px 10px", textAlign:"center", fontSize:11, color:"#999" }}>
                                No entries logged against {entity?.name} yet. Entries added here appear in the group register in Compliance.
                              </td></tr>
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>}
                  {tab!=="fatca"&&tab!=="crs"&&tab!=="substance"&&tab!=="structure"&&tab!=="egaming_reg"&&renderTab()}
                </div>
              </div>
            </>
          ):(
            <div style={{ display:"flex", alignItems:"center", justifyContent:"center", height:"100%", color:"var(--text-secondary,#666)", fontSize:13 }}>
              Select an entity from the list to view its full record.
            </div>
          )}
        </div>
      </div>

      {/* Modals */}
      {modal&&modal!=="newEntity"&&modalForms[modal]&&(
        <FormModal
          title={modalForms[modal].title}
          fields={modalForms[modal].fields}
          onSave={entityDbId && modalSaves[modal] ? modalSaves[modal] : null}
          note={
            !entityDbId ? "This entity is not loaded from the database, so nothing can be saved against it yet."
            : !modalSaves[modal] ? "This register cannot be saved to yet — the write function for it is not built."
            : null
          }
          onClose={(saved)=>{ setModal(null); if (saved) setDetVersion((v)=>v+1); }}
        />
      )}
      {modal==="newEntity"&&(
        <FormModal
          title="Add new entity"
          fields={[
            {label:"Entity name",placeholder:"Full legal name",full:true},
            {label:"Entity type",type:"select",opts:["Company","Trust","Foundation","LLC","Partnership"]},
            {label:"Jurisdiction",type:"select",opts:Object.keys(officeColors)},
            {label:"Registration number",placeholder:"Reg. number"},
            {label:"Date incorporated",placeholder:"DD/MM/YYYY"},
            {label:"Administrator",placeholder:"Name"},
            {label:"Lead director",placeholder:"Name"},
            {label:"Principal activity",type:"select",opts:["Holding company","Investment holding","Trading company","Property holding","Family trust","Wealth & estate planning","Fund / investment fund","eGaming operator","eGaming B2B supply","Yacht / aircraft ownership","Philanthropy / foundation","Intellectual property holding","Financing / treasury","Consultancy / services","Dormant","Other"]},
            {label:"Currency",type:"select",opts:["GBP","USD","EUR"]},
            {label:"Year end",placeholder:"DD/MM"},
            {label:"Initial status",type:"select",opts:["Active","Pending incorporation","Dormant"]},
          ]}
          onSave={modalSaves.newEntity}
          onClose={()=>setModal(null)}
        />
      )}

      {reportsOpen && (
        <div onClick={()=>setReportsOpen(false)} style={{ position:"fixed", inset:0, background:"rgba(0,18,66,0.45)", zIndex:200, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
          <div onClick={e=>e.stopPropagation()} style={{ background:"var(--bg-primary,#fff)", borderRadius:10, width:"min(1040px,96vw)", maxHeight:"90vh", display:"flex", flexDirection:"column", overflow:"hidden", boxShadow:"0 10px 40px rgba(0,0,0,0.3)" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"14px 18px", borderBottom:"0.5px solid #e5e5e5" }}>
              <div style={{ fontSize:15, fontWeight:600, color:"#001242" }}>Entity Admin — Reports</div>
              <button style={s.btn(false)} onClick={()=>setReportsOpen(false)}>Close ✕</button>
            </div>
            <div style={{ display:"flex", gap:6, padding:"10px 18px", borderBottom:"0.5px solid #e5e5e5", flexWrap:"wrap" }}>
              {Object.entries(REPORTS).map(([k,r])=>(
                <button key={k} onClick={()=>setRepTab(k)} style={{ padding:"5px 14px", fontSize:12, borderRadius:20, border:`0.5px solid ${repTab===k?CY:"#e5e5e5"}`, background:repTab===k?CY:"transparent", color:repTab===k?"#fff":"#666", cursor:"pointer", fontWeight:repTab===k?600:400 }}>{r.label}</button>
              ))}
            </div>
            <div style={{ padding:"14px 18px", overflow:"auto" }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                <div style={{ fontSize:12, color:"var(--text-secondary,#666)" }}>{repLoading?"Loading…":`${repRows.length} record${repRows.length===1?"":"s"}`}</div>
                <button style={s.btn(true)} onClick={exportRepCsv} disabled={!repRows.length}>⭳ Export CSV</button>
              </div>
              <table style={{ width:"100%", borderCollapse:"collapse" }}>
                <thead><tr>{REPORTS[repTab].cols.map(c=><th key={c[0]} style={{ padding:"8px 10px", textAlign:"left", fontSize:10, fontWeight:600, color:"#666", textTransform:"uppercase", letterSpacing:"0.4px", borderBottom:"0.5px solid #e5e5e5", position:"sticky", top:0, background:"var(--bg-primary,#fff)" }}>{c[1]}</th>)}</tr></thead>
                <tbody>
                  {repRows.map((r,i)=>(
                    <tr key={i} style={{ borderBottom:"0.5px solid #e5e5e5" }}>
                      {REPORTS[repTab].cols.map(c=><td key={c[0]} style={{ ...s.td, fontSize:11 }}>{r[c[0]]==null||r[c[0]]===""?"—":String(r[c[0]])}</td>)}
                    </tr>
                  ))}
                </tbody>
              </table>
              {!repLoading&&!repRows.length&&<div style={{ textAlign:"center", padding:"24px 0", color:"var(--text-secondary,#666)", fontSize:12 }}>No records for this report yet. Run the round-2 SQL (and, once the write layer is live, staff-entered records will populate these).</div>}
            </div>
          </div>
        </div>
      )}
      <ActionModal spec={act} f={actF} setF={setActF} msg={actMsg} busy={actBusy}
                   subject={actSubj}
                   onCancel={()=>{ setAct(null); setActF({}); setActMsg(""); }}
                   onSave={runAct} />

    </div>
  );
}
